// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import { type AdditionalPropertiesExample1 } from "./schema";
import { type AdditionalPropertiesExample2 } from "./schema";
import { type AdditionalPropertiesExample3 } from "./schema";
import { type AdditionalPropertiesExample4 } from "./schema";
import { type AllOfExample } from "./schema";
import { type AllOfExpandingRef } from "./schema";
import { type AllOfRefExample } from "./schema";
import { type ArrayOfArray } from "./schema";
import { type BinaryData } from "./schema";
import { type BytesData } from "./schema";
import { type DateObj } from "./schema";
import { type DateTimeObj } from "./schema";
import { type Demo1EditForm } from "./schema";
import { type Demo1ExperimentalFormDemoSaveResult } from "./schema";
import { type Demo1ValidatedForm } from "./schema";
import { type Demo1ValidationResult } from "./schema";
import { type Demo2EditForm } from "./schema";
import { type Demo2ValidatedForm } from "./schema";
import { type Demo2ValidationResult } from "./schema";
import { type Demo7EditForm } from "./schema";
import { type Demo7ValidatedForm } from "./schema";
import { type Demo7ValidationResult } from "./schema";
import { type EmptyObjectExample } from "./schema";
import { type ExampleEnum } from "./schema";
import { type ExperimentModel } from "./schema";
import { type ExperimentOptionalModel } from "./schema";
import { type ExperimentRefModel } from "./schema";
import { type ExperimentalDemoModel } from "./schema";
import { type ExternalTypeExample } from "./schema";
import { type NamedEnumInArr } from "./schema";
import { type NamedEnumInObj } from "./schema";
import { type NamingEdgecases } from "./schema";
import { type NestedBytesData } from "./schema";
import { type NonRequiredNullable } from "./schema";
import { type NullableObjectInObject } from "./schema";
import { type ObjInArrInArr } from "./schema";
import { type ObjInObjInObj } from "./schema";
import { type ObjectArrayContainer } from "./schema";
import { type OneOfEarlyName } from "./schema";
import { type OneOfExplicitDiscriminatorExample } from "./schema";
import { type OneOfExplicitDiscriminatorMultiNestingExample } from "./schema";
import { type OneOfInsideArrayExample } from "./schema";
import { type OneOfLateName } from "./schema";
import { type OneOfPartsBaseExample_A } from "./schema";
import { type OneOfPartsBaseExample_B } from "./schema";
import { type OneOfPartsBaseExample_C } from "./schema";
import { type OneOfPartsBaseExample } from "./schema";
import { type OneOfUsePartExample } from "./schema";
import { type OneOfWithOverlappingProperties } from "./schema";
import { type OneOfWithRef } from "./schema";
import { type OneOfWithRefElem } from "./schema";
import { type OneOfWithRefElemKind } from "./schema";
import { type RefArrayContainer } from "./schema";
import { type ReservedKeywords } from "./schema";
import { type StringArrayContainer } from "./schema";
import { type SubModel } from "./schema";
import { type SuperExample } from "./schema";
import { type SuperExample_AAA } from "./schema";
import { type SuperExample_BBB } from "./schema";
import { type TimeStampExample } from "./schema";
import { type UnNamedEnumInArr } from "./schema";
import { type UnnamedEnumInObj } from "./schema";
import { type UriExample } from "./schema";
import { type UrlExample } from "./schema";
import { type ValidationErrorReasons } from "./schema";
// AdditionalPropertiesExample1
export function serialize_AdditionalPropertiesExample1(obj: AdditionalPropertiesExample1): string {
  const serialized = ((value: { num: number; additionalProperties: Record<string, string> }): unknown => {
    const unordered_obj: Record<string, unknown> = {
      num: ((value: number): unknown => {
        return value;
      })(value["num"]),
      ...Object.fromEntries(
        Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
          return [
            propertyKey,
            ((value: string): unknown => {
              return value;
            })(propertyValue),
          ];
        }),
      ),
    };
    return Object.keys(unordered_obj)
      .sort()
      .reduce(
        (obj, key) => {
          obj[key] = unordered_obj[key];
          return obj;
        },
        {} as Record<string, unknown>,
      );
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_AdditionalPropertiesExample1(str: string): ParserResult<AdditionalPropertiesExample1> {
  return ((
    value: unknown,
  ): ParserResult<{
    num: number;
    additionalProperties: Record<string, string>;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample1]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample1]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "num")) {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample1/num]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'num'.` };
    }
    const parsed_num = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample1/num]: '${value}' expected to be of type number.` };
      })(value["num"]);
    })();
    if (!parsed_num.success) {
      return { success: false, reason: parsed_num.reason };
    }
    const parsed_additionalProperties = ((): ParserResult<Record<string, string>> => {
      const parsed = Object.entries(value)
        .filter(([key, _]) => !["num"].includes(key))
        .map(([key, value]): [string, ParserResult<string>] => {
          return [
            key,
            ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample1/additionalProperty]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value),
          ];
        });
      if (parsed.find(([_, value]) => !value.success) !== undefined) {
        return {
          success: false,
          reason: `[#/components/schemas/AdditionalPropertiesExample1]: Reason(s): '${parsed
            .map(([_, value]) => value)
            .filter((p) => !p.success)
            .map((p) => p.reason)
            .join(", ")}'.`,
        };
      }
      return {
        success: true,
        value: Object.fromEntries(
          parsed.map(([key, value]) => {
            assert(value.success);
            return [key, value.value];
          }),
        ),
      };
    })();
    if (!parsed_additionalProperties.success) {
      return { success: false, reason: parsed_additionalProperties.reason };
    }
    return { success: true, value: { num: parsed_num.value, additionalProperties: parsed_additionalProperties.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// AdditionalPropertiesExample2
export function serialize_AdditionalPropertiesExample2(obj: AdditionalPropertiesExample2): string {
  const serialized = ((value: {
    additionalProperties: Record<
      string,
      {
        foo?: number;
      }
    >;
  }): unknown => {
    const unordered_obj: Record<string, unknown> = {
      ...Object.fromEntries(
        Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
          return [
            propertyKey,
            ((value: { foo?: number }): unknown => {
              return {
                foo: ((value: number | undefined): unknown => {
                  if (value === undefined) {
                    return undefined;
                  }
                  return value;
                })(value["foo"]),
              };
            })(propertyValue),
          ];
        }),
      ),
    };
    return Object.keys(unordered_obj)
      .sort()
      .reduce(
        (obj, key) => {
          obj[key] = unordered_obj[key];
          return obj;
        },
        {} as Record<string, unknown>,
      );
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_AdditionalPropertiesExample2(str: string): ParserResult<AdditionalPropertiesExample2> {
  return ((
    value: unknown,
  ): ParserResult<{
    additionalProperties: Record<
      string,
      {
        foo?: number;
      }
    >;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample2]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample2]: '${value}' expected to not be null.` };
    }
    const parsed_additionalProperties = ((): ParserResult<
      Record<
        string,
        {
          foo?: number;
        }
      >
    > => {
      const parsed = Object.entries(value).map(
        ([key, value]): [
          string,
          ParserResult<{
            foo?: number;
          }>,
        ] => {
          return [
            key,
            ((
              value: unknown,
            ): ParserResult<{
              foo?: number;
            }> => {
              if (typeof value !== "object") {
                return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample2/[object]]: '${value}' expected to be of type 'object'.` };
              }
              if (value === null) {
                return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample2/[object]]: '${value}' expected to not be null.` };
              }
              const parsed_foo = ((): ParserResult<number | undefined> => {
                if (!hasProp(value, "foo")) {
                  return { success: true, value: undefined };
                }
                return ((value: unknown): ParserResult<number | undefined> => {
                  if (value === undefined) {
                    return { success: true, value: undefined };
                  }
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample2/[object]/foo]: '${value}' expected to be of type number.` };
                })(value["foo"]);
              })();
              if (!parsed_foo.success) {
                return { success: false, reason: parsed_foo.reason };
              }
              return { success: true, value: { foo: parsed_foo.value } };
            })(value),
          ];
        },
      );
      if (parsed.find(([_, value]) => !value.success) !== undefined) {
        return {
          success: false,
          reason: `[#/components/schemas/AdditionalPropertiesExample2]: Reason(s): '${parsed
            .map(([_, value]) => value)
            .filter((p) => !p.success)
            .map((p) => p.reason)
            .join(", ")}'.`,
        };
      }
      return {
        success: true,
        value: Object.fromEntries(
          parsed.map(([key, value]) => {
            assert(value.success);
            return [key, value.value];
          }),
        ),
      };
    })();
    if (!parsed_additionalProperties.success) {
      return { success: false, reason: parsed_additionalProperties.reason };
    }
    return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// AdditionalPropertiesExample3
export function serialize_AdditionalPropertiesExample3(obj: AdditionalPropertiesExample3): string {
  const serialized = ((value: { additionalProperties: Record<string, number | null> }): unknown => {
    const unordered_obj: Record<string, unknown> = {
      ...Object.fromEntries(
        Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
          return [
            propertyKey,
            ((value: number | null): unknown => {
              if (value === null) {
                return null;
              }
              return value;
            })(propertyValue),
          ];
        }),
      ),
    };
    return Object.keys(unordered_obj)
      .sort()
      .reduce(
        (obj, key) => {
          obj[key] = unordered_obj[key];
          return obj;
        },
        {} as Record<string, unknown>,
      );
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_AdditionalPropertiesExample3(str: string): ParserResult<AdditionalPropertiesExample3> {
  return ((value: unknown): ParserResult<{ additionalProperties: Record<string, number | null> }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample3]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample3]: '${value}' expected to not be null.` };
    }
    const parsed_additionalProperties = ((): ParserResult<Record<string, number | null>> => {
      const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<number | null>] => {
        return [
          key,
          ((value: unknown): ParserResult<number | null> => {
            if (value === null) {
              return { success: true, value: null };
            }
            if (typeof value === "number") {
              return { success: true, value: value };
            }
            return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample3/additionalProperty]: '${value}' expected to be of type number.` };
          })(value),
        ];
      });
      if (parsed.find(([_, value]) => !value.success) !== undefined) {
        return {
          success: false,
          reason: `[#/components/schemas/AdditionalPropertiesExample3]: Reason(s): '${parsed
            .map(([_, value]) => value)
            .filter((p) => !p.success)
            .map((p) => p.reason)
            .join(", ")}'.`,
        };
      }
      return {
        success: true,
        value: Object.fromEntries(
          parsed.map(([key, value]) => {
            assert(value.success);
            return [key, value.value];
          }),
        ),
      };
    })();
    if (!parsed_additionalProperties.success) {
      return { success: false, reason: parsed_additionalProperties.reason };
    }
    return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// AdditionalPropertiesExample4
export function serialize_AdditionalPropertiesExample4(obj: AdditionalPropertiesExample4): string {
  const serialized = ((value: { subobj: { additionalProperties: Record<string, string> } }): unknown => {
    return {
      subobj: ((value: { additionalProperties: Record<string, string> }): unknown => {
        const unordered_obj: Record<string, unknown> = {
          ...Object.fromEntries(
            Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
              return [
                propertyKey,
                ((value: string): unknown => {
                  return value;
                })(propertyValue),
              ];
            }),
          ),
        };
        return Object.keys(unordered_obj)
          .sort()
          .reduce(
            (obj, key) => {
              obj[key] = unordered_obj[key];
              return obj;
            },
            {} as Record<string, unknown>,
          );
      })(value["subobj"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_AdditionalPropertiesExample4(str: string): ParserResult<AdditionalPropertiesExample4> {
  return ((
    value: unknown,
  ): ParserResult<{
    subobj: { additionalProperties: Record<string, string> };
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample4]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample4]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "subobj")) {
      return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample4/subobj]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subobj'.` };
    }
    const parsed_subobj = ((): ParserResult<{ additionalProperties: Record<string, string> }> => {
      return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string> }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample4/subobj]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample4/subobj]: '${value}' expected to not be null.` };
        }
        const parsed_additionalProperties = ((): ParserResult<Record<string, string>> => {
          const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string>] => {
            return [
              key,
              ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/AdditionalPropertiesExample4/subobj/additionalProperty]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value),
            ];
          });
          if (parsed.find(([_, value]) => !value.success) !== undefined) {
            return {
              success: false,
              reason: `[#/components/schemas/AdditionalPropertiesExample4/subobj]: Reason(s): '${parsed
                .map(([_, value]) => value)
                .filter((p) => !p.success)
                .map((p) => p.reason)
                .join(", ")}'.`,
            };
          }
          return {
            success: true,
            value: Object.fromEntries(
              parsed.map(([key, value]) => {
                assert(value.success);
                return [key, value.value];
              }),
            ),
          };
        })();
        if (!parsed_additionalProperties.success) {
          return { success: false, reason: parsed_additionalProperties.reason };
        }
        return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
      })(value["subobj"]);
    })();
    if (!parsed_subobj.success) {
      return { success: false, reason: parsed_subobj.reason };
    }
    return { success: true, value: { subobj: parsed_subobj.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// AllOfExample
export function serialize_AllOfExample(obj: AllOfExample): string {
  const serialized = ((value: { a: string; b: string; c: string; d?: string; e: string; f?: string }): unknown => {
    return {
      a: ((value: string): unknown => {
        return value;
      })(value["a"]),
      b: ((value: string): unknown => {
        return value;
      })(value["b"]),
      c: ((value: string): unknown => {
        return value;
      })(value["c"]),
      d: ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["d"]),
      e: ((value: string): unknown => {
        return value;
      })(value["e"]),
      f: ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["f"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_AllOfExample(str: string): ParserResult<AllOfExample> {
  return ((
    value: unknown,
  ): ParserResult<{
    a: string;
    b: string;
    c: string;
    d?: string;
    e: string;
    f?: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AllOfExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AllOfExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "a")) {
      return { success: false, reason: `[#/components/schemas/AllOfExample/a]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'a'.` };
    }
    const parsed_a = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExample/a]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["a"]);
    })();
    if (!parsed_a.success) {
      return { success: false, reason: parsed_a.reason };
    }
    if (!hasProp(value, "b")) {
      return { success: false, reason: `[#/components/schemas/AllOfExample/b]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'b'.` };
    }
    const parsed_b = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExample/b]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["b"]);
    })();
    if (!parsed_b.success) {
      return { success: false, reason: parsed_b.reason };
    }
    if (!hasProp(value, "c")) {
      return { success: false, reason: `[#/components/schemas/AllOfExample/c]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'c'.` };
    }
    const parsed_c = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExample/c]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["c"]);
    })();
    if (!parsed_c.success) {
      return { success: false, reason: parsed_c.reason };
    }
    const parsed_d = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "d")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExample/d]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["d"]);
    })();
    if (!parsed_d.success) {
      return { success: false, reason: parsed_d.reason };
    }
    if (!hasProp(value, "e")) {
      return { success: false, reason: `[#/components/schemas/AllOfExample/e]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'e'.` };
    }
    const parsed_e = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExample/e]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["e"]);
    })();
    if (!parsed_e.success) {
      return { success: false, reason: parsed_e.reason };
    }
    const parsed_f = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "f")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExample/f]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["f"]);
    })();
    if (!parsed_f.success) {
      return { success: false, reason: parsed_f.reason };
    }
    return { success: true, value: { a: parsed_a.value, b: parsed_b.value, c: parsed_c.value, d: parsed_d.value, e: parsed_e.value, f: parsed_f.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// AllOfExpandingRef
export function serialize_AllOfExpandingRef(obj: AllOfExpandingRef): string {
  const serialized = ((value: { a: string; b: string; c: string; d?: string; e: string; f?: string; x: string; y: string }): unknown => {
    return {
      a: ((value: string): unknown => {
        return value;
      })(value["a"]),
      b: ((value: string): unknown => {
        return value;
      })(value["b"]),
      c: ((value: string): unknown => {
        return value;
      })(value["c"]),
      d: ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["d"]),
      e: ((value: string): unknown => {
        return value;
      })(value["e"]),
      f: ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["f"]),
      x: ((value: string): unknown => {
        return value;
      })(value["x"]),
      y: ((value: string): unknown => {
        return value;
      })(value["y"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_AllOfExpandingRef(str: string): ParserResult<AllOfExpandingRef> {
  return ((
    value: unknown,
  ): ParserResult<{
    a: string;
    b: string;
    c: string;
    d?: string;
    e: string;
    f?: string;
    x: string;
    y: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AllOfExpandingRef]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AllOfExpandingRef]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "a")) {
      return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/a]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'a'.` };
    }
    const parsed_a = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/a]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["a"]);
    })();
    if (!parsed_a.success) {
      return { success: false, reason: parsed_a.reason };
    }
    if (!hasProp(value, "b")) {
      return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/b]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'b'.` };
    }
    const parsed_b = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/b]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["b"]);
    })();
    if (!parsed_b.success) {
      return { success: false, reason: parsed_b.reason };
    }
    if (!hasProp(value, "c")) {
      return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/c]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'c'.` };
    }
    const parsed_c = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/c]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["c"]);
    })();
    if (!parsed_c.success) {
      return { success: false, reason: parsed_c.reason };
    }
    const parsed_d = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "d")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/d]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["d"]);
    })();
    if (!parsed_d.success) {
      return { success: false, reason: parsed_d.reason };
    }
    if (!hasProp(value, "e")) {
      return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/e]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'e'.` };
    }
    const parsed_e = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/e]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["e"]);
    })();
    if (!parsed_e.success) {
      return { success: false, reason: parsed_e.reason };
    }
    const parsed_f = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "f")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/f]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["f"]);
    })();
    if (!parsed_f.success) {
      return { success: false, reason: parsed_f.reason };
    }
    if (!hasProp(value, "x")) {
      return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/x]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'x'.` };
    }
    const parsed_x = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/x]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["x"]);
    })();
    if (!parsed_x.success) {
      return { success: false, reason: parsed_x.reason };
    }
    if (!hasProp(value, "y")) {
      return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/y]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'y'.` };
    }
    const parsed_y = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AllOfExpandingRef/y]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["y"]);
    })();
    if (!parsed_y.success) {
      return { success: false, reason: parsed_y.reason };
    }
    return { success: true, value: { a: parsed_a.value, b: parsed_b.value, c: parsed_c.value, d: parsed_d.value, e: parsed_e.value, f: parsed_f.value, x: parsed_x.value, y: parsed_y.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// AllOfRefExample
export function serialize_AllOfRefExample(obj: AllOfRefExample): string {
  const serialized = ((value: { a: AllOfExample | null }): unknown => {
    return {
      a: ((
        value: {
          a: string;
          b: string;
          c: string;
          d?: string;
          e: string;
          f?: string;
        } | null,
      ): unknown => {
        if (value === null) {
          return null;
        }
        return {
          a: ((value: string): unknown => {
            return value;
          })(value["a"]),
          b: ((value: string): unknown => {
            return value;
          })(value["b"]),
          c: ((value: string): unknown => {
            return value;
          })(value["c"]),
          d: ((value: string | undefined): unknown => {
            if (value === undefined) {
              return undefined;
            }
            return value;
          })(value["d"]),
          e: ((value: string): unknown => {
            return value;
          })(value["e"]),
          f: ((value: string | undefined): unknown => {
            if (value === undefined) {
              return undefined;
            }
            return value;
          })(value["f"]),
        };
      })(value["a"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_AllOfRefExample(str: string): ParserResult<AllOfRefExample> {
  return ((
    value: unknown,
  ): ParserResult<{
    a: AllOfExample | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AllOfRefExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AllOfRefExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "a")) {
      return { success: false, reason: `[#/components/schemas/AllOfRefExample/a]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'a'.` };
    }
    const parsed_a = ((): ParserResult<AllOfExample | null> => {
      return ((value: unknown): ParserResult<AllOfExample | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return ((
          value: unknown,
        ): ParserResult<{
          a: string;
          b: string;
          c: string;
          d?: string;
          e: string;
          f?: string;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/AllOfExample]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/AllOfExample]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "a")) {
            return { success: false, reason: `[#/components/schemas/AllOfExample/a]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'a'.` };
          }
          const parsed_a = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AllOfExample/a]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["a"]);
          })();
          if (!parsed_a.success) {
            return { success: false, reason: parsed_a.reason };
          }
          if (!hasProp(value, "b")) {
            return { success: false, reason: `[#/components/schemas/AllOfExample/b]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'b'.` };
          }
          const parsed_b = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AllOfExample/b]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["b"]);
          })();
          if (!parsed_b.success) {
            return { success: false, reason: parsed_b.reason };
          }
          if (!hasProp(value, "c")) {
            return { success: false, reason: `[#/components/schemas/AllOfExample/c]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'c'.` };
          }
          const parsed_c = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AllOfExample/c]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["c"]);
          })();
          if (!parsed_c.success) {
            return { success: false, reason: parsed_c.reason };
          }
          const parsed_d = ((): ParserResult<string | undefined> => {
            if (!hasProp(value, "d")) {
              return { success: true, value: undefined };
            }
            return ((value: unknown): ParserResult<string | undefined> => {
              if (value === undefined) {
                return { success: true, value: undefined };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AllOfExample/d]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["d"]);
          })();
          if (!parsed_d.success) {
            return { success: false, reason: parsed_d.reason };
          }
          if (!hasProp(value, "e")) {
            return { success: false, reason: `[#/components/schemas/AllOfExample/e]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'e'.` };
          }
          const parsed_e = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AllOfExample/e]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["e"]);
          })();
          if (!parsed_e.success) {
            return { success: false, reason: parsed_e.reason };
          }
          const parsed_f = ((): ParserResult<string | undefined> => {
            if (!hasProp(value, "f")) {
              return { success: true, value: undefined };
            }
            return ((value: unknown): ParserResult<string | undefined> => {
              if (value === undefined) {
                return { success: true, value: undefined };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AllOfExample/f]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["f"]);
          })();
          if (!parsed_f.success) {
            return { success: false, reason: parsed_f.reason };
          }
          return { success: true, value: { a: parsed_a.value, b: parsed_b.value, c: parsed_c.value, d: parsed_d.value, e: parsed_e.value, f: parsed_f.value } };
        })(value);
      })(value["a"]);
    })();
    if (!parsed_a.success) {
      return { success: false, reason: parsed_a.reason };
    }
    return { success: true, value: { a: parsed_a.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// ArrayOfArray
export function serialize_ArrayOfArray(obj: ArrayOfArray): string {
  const serialized = ((value: { arr_of_arr: number[][] }): unknown => {
    return {
      arr_of_arr: ((value: number[][]): unknown => {
        return value.map((value: number[]): unknown => {
          return value.map((value: number): unknown => {
            return value;
          });
        });
      })(value["arr_of_arr"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ArrayOfArray(str: string): ParserResult<ArrayOfArray> {
  return ((
    value: unknown,
  ): ParserResult<{
    arr_of_arr: number[][];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ArrayOfArray]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ArrayOfArray]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "arr_of_arr")) {
      return { success: false, reason: `[#/components/schemas/ArrayOfArray/arr_of_arr]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr_of_arr'.` };
    }
    const parsed_arr_of_arr = ((): ParserResult<number[][]> => {
      return ((value: unknown): ParserResult<number[][]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ArrayOfArray/arr_of_arr]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<number[]> => {
          if (!isArray(value)) {
            return { success: false, reason: `[#/components/schemas/ArrayOfArray/arr_of_arr/[array]]: '${value}' expected to be an array.` };
          }
          const parsed = value.map((value: unknown): ParserResult<number> => {
            if (typeof value === "number") {
              return { success: true, value: value };
            }
            return { success: false, reason: `[#/components/schemas/ArrayOfArray/arr_of_arr]: '${value}' expected to be of type number.` };
          });
          if (parsed.find((value) => !value.success) !== undefined) {
            return {
              success: false,
              reason: `[#/components/schemas/ArrayOfArray/arr_of_arr/[array]]: Reason(s): '${parsed
                .filter((p) => !p.success)
                .map((p) => p.reason)
                .join(", ")}'.`,
            };
          }
          return {
            success: true,
            value: parsed.map((entry) => {
              assert(entry.success == true);
              return entry.value;
            }),
          };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ArrayOfArray/arr_of_arr]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr_of_arr"]);
    })();
    if (!parsed_arr_of_arr.success) {
      return { success: false, reason: parsed_arr_of_arr.reason };
    }
    return { success: true, value: { arr_of_arr: parsed_arr_of_arr.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// BinaryData
export function serialize_BinaryData(obj: BinaryData): string {
  const serialized = ((value: { file: ReadonlyUint8Array }): unknown => {
    return {
      file: ((value: ReadonlyUint8Array): unknown => {
        return toBase64(value);
      })(value["file"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_BinaryData(str: string): ParserResult<BinaryData> {
  return ((
    value: unknown,
  ): ParserResult<{
    file: ReadonlyUint8Array;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/BinaryData]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/BinaryData]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "file")) {
      return { success: false, reason: `[#/components/schemas/BinaryData/file]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'file'.` };
    }
    const parsed_file = ((): ParserResult<ReadonlyUint8Array> => {
      return ((value: unknown): ParserResult<ReadonlyUint8Array> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/BinaryData/file]: '${value}' expected to be of type string.` };
        }
        const binary = (() => {
          try {
            const binaryString = atob(value);
            const arr = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
              arr[i] = binaryString.charCodeAt(i);
            }
            return arr;
          } catch (ex) {
            return null;
          }
        })();
        if (binary === null) {
          return { success: false, reason: `[#/components/schemas/BinaryData/file]: '${value}' expected to be a valid base64 string.` };
        }
        return { success: true, value: binary };
      })(value["file"]);
    })();
    if (!parsed_file.success) {
      return { success: false, reason: parsed_file.reason };
    }
    return { success: true, value: { file: parsed_file.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// BytesData
export function serialize_BytesData(obj: BytesData): string {
  const serialized = ((value: { data: ReadonlyUint8Array }): unknown => {
    return {
      data: ((value: ReadonlyUint8Array): unknown => {
        return toBase64(value);
      })(value["data"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_BytesData(str: string): ParserResult<BytesData> {
  return ((
    value: unknown,
  ): ParserResult<{
    data: ReadonlyUint8Array;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/BytesData]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/BytesData]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "data")) {
      return { success: false, reason: `[#/components/schemas/BytesData/data]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'data'.` };
    }
    const parsed_data = ((): ParserResult<ReadonlyUint8Array> => {
      return ((value: unknown): ParserResult<ReadonlyUint8Array> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/BytesData/data]: '${value}' expected to be of type string.` };
        }
        const binary = (() => {
          try {
            const binaryString = atob(value);
            const arr = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
              arr[i] = binaryString.charCodeAt(i);
            }
            return arr;
          } catch (ex) {
            return null;
          }
        })();
        if (binary === null) {
          return { success: false, reason: `[#/components/schemas/BytesData/data]: '${value}' expected to be a valid base64 string.` };
        }
        return { success: true, value: binary };
      })(value["data"]);
    })();
    if (!parsed_data.success) {
      return { success: false, reason: parsed_data.reason };
    }
    return { success: true, value: { data: parsed_data.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// DateObj
export function serialize_DateObj(obj: DateObj): string {
  const serialized = ((value: { dt?: { year: number; month: number; day: number } | null }): unknown => {
    return {
      dt: ((value: { year: number; month: number; day: number } | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
      })(value["dt"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_DateObj(str: string): ParserResult<DateObj> {
  return ((
    value: unknown,
  ): ParserResult<{
    dt?: { year: number; month: number; day: number } | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/DateObj]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/DateObj]: '${value}' expected to not be null.` };
    }
    const parsed_dt = ((): ParserResult<{ year: number; month: number; day: number } | null | undefined> => {
      if (!hasProp(value, "dt")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<{ year: number; month: number; day: number } | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/DateObj/dt]: '${value}' expected to be of type string.` };
        }
        const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/DateObj/dt]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
        }
        return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
      })(value["dt"]);
    })();
    if (!parsed_dt.success) {
      return { success: false, reason: parsed_dt.reason };
    }
    return { success: true, value: { dt: parsed_dt.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// DateTimeObj
export function serialize_DateTimeObj(obj: DateTimeObj): string {
  const serialized = ((value: { dt?: DateTime<true> | null }): unknown => {
    return {
      dt: ((value: DateTime<true> | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value.toISO();
      })(value["dt"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_DateTimeObj(str: string): ParserResult<DateTimeObj> {
  return ((
    value: unknown,
  ): ParserResult<{
    dt?: DateTime<true> | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/DateTimeObj]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/DateTimeObj]: '${value}' expected to not be null.` };
    }
    const parsed_dt = ((): ParserResult<DateTime<true> | null | undefined> => {
      if (!hasProp(value, "dt")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<DateTime<true> | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/DateTimeObj/dt]: '${value}' expected to be of type string.` };
        }
        const parsed = DateTime.fromISO(value.toUpperCase(), { setZone: true });
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/DateTimeObj/dt]: '${value}' expected to be a valid ISO date.` };
        }
        return { success: true, value: parsed };
      })(value["dt"]);
    })();
    if (!parsed_dt.success) {
      return { success: false, reason: parsed_dt.reason };
    }
    return { success: true, value: { dt: parsed_dt.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo1EditForm
export function serialize_Demo1EditForm(obj: Demo1EditForm): string {
  const serialized = ((value: { firstname: string; lastname: string }): unknown => {
    return {
      firstname: ((value: string): unknown => {
        return value;
      })(value["firstname"]),
      lastname: ((value: string): unknown => {
        return value;
      })(value["lastname"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo1EditForm(str: string): ParserResult<Demo1EditForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    firstname: string;
    lastname: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/Demo1EditForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/Demo1EditForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "firstname")) {
      return { success: false, reason: `[#/components/schemas/Demo1EditForm/firstname]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstname'.` };
    }
    const parsed_firstname = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo1EditForm/firstname]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["firstname"]);
    })();
    if (!parsed_firstname.success) {
      return { success: false, reason: parsed_firstname.reason };
    }
    if (!hasProp(value, "lastname")) {
      return { success: false, reason: `[#/components/schemas/Demo1EditForm/lastname]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastname'.` };
    }
    const parsed_lastname = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo1EditForm/lastname]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["lastname"]);
    })();
    if (!parsed_lastname.success) {
      return { success: false, reason: parsed_lastname.reason };
    }
    return { success: true, value: { firstname: parsed_firstname.value, lastname: parsed_lastname.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo1ExperimentalFormDemoSaveResult
export function serialize_Demo1ExperimentalFormDemoSaveResult(obj: Demo1ExperimentalFormDemoSaveResult): string {
  const serialized = ((value: { kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: DateObj }): unknown => {
    switch (value.kind) {
      case "ERROR": {
        return {
          kind: "ERROR",
          reasons: ((value: { fields: { additionalProperties: Record<string, string[]> }; general: string[] }): unknown => {
            return {
              fields: ((value: { additionalProperties: Record<string, string[]> }): unknown => {
                const unordered_obj: Record<string, unknown> = {
                  ...Object.fromEntries(
                    Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
                      return [
                        propertyKey,
                        ((value: string[]): unknown => {
                          return value.map((value: string): unknown => {
                            return value;
                          });
                        })(propertyValue),
                      ];
                    }),
                  ),
                };
                return Object.keys(unordered_obj)
                  .sort()
                  .reduce(
                    (obj, key) => {
                      obj[key] = unordered_obj[key];
                      return obj;
                    },
                    {} as Record<string, unknown>,
                  );
              })(value["fields"]),
              general: ((value: string[]): unknown => {
                return value.map((value: string): unknown => {
                  return value;
                });
              })(value["general"]),
            };
          })(value["reasons"]),
        };
      }
      case "SUCCESS": {
        return {
          kind: "SUCCESS",
          validatedForm: ((value: { dt?: { year: number; month: number; day: number } | null }): unknown => {
            return {
              dt: ((value: { year: number; month: number; day: number } | null | undefined): unknown => {
                if (value === undefined) {
                  return undefined;
                }
                if (value === null) {
                  return null;
                }
                return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
              })(value["dt"]),
            };
          })(value["validatedForm"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo1ExperimentalFormDemoSaveResult(str: string): ParserResult<Demo1ExperimentalFormDemoSaveResult> {
  return ((value: unknown): ParserResult<{ kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: DateObj }> => {
    return ((value: unknown): ParserResult<{ kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: DateObj }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "ERROR": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            reasons: ValidationErrorReasons;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult/ERROR]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult/ERROR]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "reasons")) {
              return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult/ERROR/reasons]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reasons'.` };
            }
            const parsed_reasons = ((): ParserResult<ValidationErrorReasons> => {
              return ((value: unknown): ParserResult<ValidationErrorReasons> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  fields: { additionalProperties: Record<string, string[]> };
                  general: string[];
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "fields")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fields'.` };
                  }
                  const parsed_fields = ((): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                    return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to not be null.` };
                      }
                      const parsed_additionalProperties = ((): ParserResult<Record<string, string[]>> => {
                        const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string[]>] => {
                          return [
                            key,
                            ((value: unknown): ParserResult<string[]> => {
                              if (!isArray(value)) {
                                return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: '${value}' expected to be an array.` };
                              }
                              const parsed = value.map((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/additionalProperty]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              });
                              if (parsed.find((value) => !value.success) !== undefined) {
                                return {
                                  success: false,
                                  reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: Reason(s): '${parsed
                                    .filter((p) => !p.success)
                                    .map((p) => p.reason)
                                    .join(", ")}'.`,
                                };
                              }
                              return {
                                success: true,
                                value: parsed.map((entry) => {
                                  assert(entry.success == true);
                                  return entry.value;
                                }),
                              };
                            })(value),
                          ];
                        });
                        if (parsed.find(([_, value]) => !value.success) !== undefined) {
                          return {
                            success: false,
                            reason: `[#/components/schemas/ValidationErrorReasons/fields]: Reason(s): '${parsed
                              .map(([_, value]) => value)
                              .filter((p) => !p.success)
                              .map((p) => p.reason)
                              .join(", ")}'.`,
                          };
                        }
                        return {
                          success: true,
                          value: Object.fromEntries(
                            parsed.map(([key, value]) => {
                              assert(value.success);
                              return [key, value.value];
                            }),
                          ),
                        };
                      })();
                      if (!parsed_additionalProperties.success) {
                        return { success: false, reason: parsed_additionalProperties.reason };
                      }
                      return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
                    })(value["fields"]);
                  })();
                  if (!parsed_fields.success) {
                    return { success: false, reason: parsed_fields.reason };
                  }
                  if (!hasProp(value, "general")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'general'.` };
                  }
                  const parsed_general = ((): ParserResult<string[]> => {
                    return ((value: unknown): ParserResult<string[]> => {
                      if (!isArray(value)) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be an array.` };
                      }
                      const parsed = value.map((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      });
                      if (parsed.find((value) => !value.success) !== undefined) {
                        return {
                          success: false,
                          reason: `[#/components/schemas/ValidationErrorReasons/general]: Reason(s): '${parsed
                            .filter((p) => !p.success)
                            .map((p) => p.reason)
                            .join(", ")}'.`,
                        };
                      }
                      return {
                        success: true,
                        value: parsed.map((entry) => {
                          assert(entry.success == true);
                          return entry.value;
                        }),
                      };
                    })(value["general"]);
                  })();
                  if (!parsed_general.success) {
                    return { success: false, reason: parsed_general.reason };
                  }
                  return { success: true, value: { fields: parsed_fields.value, general: parsed_general.value } };
                })(value);
              })(value["reasons"]);
            })();
            if (!parsed_reasons.success) {
              return { success: false, reason: parsed_reasons.reason };
            }
            return { success: true, value: { reasons: parsed_reasons.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "ERROR" as const, ...parsedVariant.value } };
        }
        case "SUCCESS": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            validatedForm: DateObj;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult/SUCCESS]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult/SUCCESS]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "validatedForm")) {
              return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult/SUCCESS/validatedForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'validatedForm'.` };
            }
            const parsed_validatedForm = ((): ParserResult<DateObj> => {
              return ((value: unknown): ParserResult<DateObj> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  dt?: { year: number; month: number; day: number } | null;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/DateObj]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/DateObj]: '${value}' expected to not be null.` };
                  }
                  const parsed_dt = ((): ParserResult<{ year: number; month: number; day: number } | null | undefined> => {
                    if (!hasProp(value, "dt")) {
                      return { success: true, value: undefined };
                    }
                    return ((value: unknown): ParserResult<{ year: number; month: number; day: number } | null | undefined> => {
                      if (value === undefined) {
                        return { success: true, value: undefined };
                      }
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/DateObj/dt]: '${value}' expected to be of type string.` };
                      }
                      const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
                      if (!parsed.isValid) {
                        return { success: false, reason: `[#/components/schemas/DateObj/dt]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
                      }
                      return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
                    })(value["dt"]);
                  })();
                  if (!parsed_dt.success) {
                    return { success: false, reason: parsed_dt.reason };
                  }
                  return { success: true, value: { dt: parsed_dt.value } };
                })(value);
              })(value["validatedForm"]);
            })();
            if (!parsed_validatedForm.success) {
              return { success: false, reason: parsed_validatedForm.reason };
            }
            return { success: true, value: { validatedForm: parsed_validatedForm.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "SUCCESS" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/Demo1ExperimentalFormDemoSaveResult]: '${discriminator}' expected to be one of 'ERROR, SUCCESS'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo1ValidatedForm
export function serialize_Demo1ValidatedForm(obj: Demo1ValidatedForm): string {
  const serialized = ((value: { firstname: string; lastname: string }): unknown => {
    return {
      firstname: ((value: string): unknown => {
        return value;
      })(value["firstname"]),
      lastname: ((value: string): unknown => {
        return value;
      })(value["lastname"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo1ValidatedForm(str: string): ParserResult<Demo1ValidatedForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    firstname: string;
    lastname: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "firstname")) {
      return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm/firstname]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstname'.` };
    }
    const parsed_firstname = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm/firstname]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["firstname"]);
    })();
    if (!parsed_firstname.success) {
      return { success: false, reason: parsed_firstname.reason };
    }
    if (!hasProp(value, "lastname")) {
      return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm/lastname]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastname'.` };
    }
    const parsed_lastname = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm/lastname]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["lastname"]);
    })();
    if (!parsed_lastname.success) {
      return { success: false, reason: parsed_lastname.reason };
    }
    return { success: true, value: { firstname: parsed_firstname.value, lastname: parsed_lastname.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo1ValidationResult
export function serialize_Demo1ValidationResult(obj: Demo1ValidationResult): string {
  const serialized = ((value: { kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: Demo1ValidatedForm }): unknown => {
    switch (value.kind) {
      case "ERROR": {
        return {
          kind: "ERROR",
          reasons: ((value: { fields: { additionalProperties: Record<string, string[]> }; general: string[] }): unknown => {
            return {
              fields: ((value: { additionalProperties: Record<string, string[]> }): unknown => {
                const unordered_obj: Record<string, unknown> = {
                  ...Object.fromEntries(
                    Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
                      return [
                        propertyKey,
                        ((value: string[]): unknown => {
                          return value.map((value: string): unknown => {
                            return value;
                          });
                        })(propertyValue),
                      ];
                    }),
                  ),
                };
                return Object.keys(unordered_obj)
                  .sort()
                  .reduce(
                    (obj, key) => {
                      obj[key] = unordered_obj[key];
                      return obj;
                    },
                    {} as Record<string, unknown>,
                  );
              })(value["fields"]),
              general: ((value: string[]): unknown => {
                return value.map((value: string): unknown => {
                  return value;
                });
              })(value["general"]),
            };
          })(value["reasons"]),
        };
      }
      case "SUCCESS": {
        return {
          kind: "SUCCESS",
          validatedForm: ((value: { firstname: string; lastname: string }): unknown => {
            return {
              firstname: ((value: string): unknown => {
                return value;
              })(value["firstname"]),
              lastname: ((value: string): unknown => {
                return value;
              })(value["lastname"]),
            };
          })(value["validatedForm"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo1ValidationResult(str: string): ParserResult<Demo1ValidationResult> {
  return ((value: unknown): ParserResult<{ kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: Demo1ValidatedForm }> => {
    return ((value: unknown): ParserResult<{ kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: Demo1ValidatedForm }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/Demo1ValidationResult]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/Demo1ValidationResult]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/Demo1ValidationResult]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/Demo1ValidationResult]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "ERROR": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            reasons: ValidationErrorReasons;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Demo1ValidationResult/ERROR]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Demo1ValidationResult/ERROR]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "reasons")) {
              return { success: false, reason: `[#/components/schemas/Demo1ValidationResult/ERROR/reasons]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reasons'.` };
            }
            const parsed_reasons = ((): ParserResult<ValidationErrorReasons> => {
              return ((value: unknown): ParserResult<ValidationErrorReasons> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  fields: { additionalProperties: Record<string, string[]> };
                  general: string[];
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "fields")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fields'.` };
                  }
                  const parsed_fields = ((): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                    return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to not be null.` };
                      }
                      const parsed_additionalProperties = ((): ParserResult<Record<string, string[]>> => {
                        const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string[]>] => {
                          return [
                            key,
                            ((value: unknown): ParserResult<string[]> => {
                              if (!isArray(value)) {
                                return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: '${value}' expected to be an array.` };
                              }
                              const parsed = value.map((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/additionalProperty]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              });
                              if (parsed.find((value) => !value.success) !== undefined) {
                                return {
                                  success: false,
                                  reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: Reason(s): '${parsed
                                    .filter((p) => !p.success)
                                    .map((p) => p.reason)
                                    .join(", ")}'.`,
                                };
                              }
                              return {
                                success: true,
                                value: parsed.map((entry) => {
                                  assert(entry.success == true);
                                  return entry.value;
                                }),
                              };
                            })(value),
                          ];
                        });
                        if (parsed.find(([_, value]) => !value.success) !== undefined) {
                          return {
                            success: false,
                            reason: `[#/components/schemas/ValidationErrorReasons/fields]: Reason(s): '${parsed
                              .map(([_, value]) => value)
                              .filter((p) => !p.success)
                              .map((p) => p.reason)
                              .join(", ")}'.`,
                          };
                        }
                        return {
                          success: true,
                          value: Object.fromEntries(
                            parsed.map(([key, value]) => {
                              assert(value.success);
                              return [key, value.value];
                            }),
                          ),
                        };
                      })();
                      if (!parsed_additionalProperties.success) {
                        return { success: false, reason: parsed_additionalProperties.reason };
                      }
                      return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
                    })(value["fields"]);
                  })();
                  if (!parsed_fields.success) {
                    return { success: false, reason: parsed_fields.reason };
                  }
                  if (!hasProp(value, "general")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'general'.` };
                  }
                  const parsed_general = ((): ParserResult<string[]> => {
                    return ((value: unknown): ParserResult<string[]> => {
                      if (!isArray(value)) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be an array.` };
                      }
                      const parsed = value.map((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      });
                      if (parsed.find((value) => !value.success) !== undefined) {
                        return {
                          success: false,
                          reason: `[#/components/schemas/ValidationErrorReasons/general]: Reason(s): '${parsed
                            .filter((p) => !p.success)
                            .map((p) => p.reason)
                            .join(", ")}'.`,
                        };
                      }
                      return {
                        success: true,
                        value: parsed.map((entry) => {
                          assert(entry.success == true);
                          return entry.value;
                        }),
                      };
                    })(value["general"]);
                  })();
                  if (!parsed_general.success) {
                    return { success: false, reason: parsed_general.reason };
                  }
                  return { success: true, value: { fields: parsed_fields.value, general: parsed_general.value } };
                })(value);
              })(value["reasons"]);
            })();
            if (!parsed_reasons.success) {
              return { success: false, reason: parsed_reasons.reason };
            }
            return { success: true, value: { reasons: parsed_reasons.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "ERROR" as const, ...parsedVariant.value } };
        }
        case "SUCCESS": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            validatedForm: Demo1ValidatedForm;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Demo1ValidationResult/SUCCESS]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Demo1ValidationResult/SUCCESS]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "validatedForm")) {
              return { success: false, reason: `[#/components/schemas/Demo1ValidationResult/SUCCESS/validatedForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'validatedForm'.` };
            }
            const parsed_validatedForm = ((): ParserResult<Demo1ValidatedForm> => {
              return ((value: unknown): ParserResult<Demo1ValidatedForm> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  firstname: string;
                  lastname: string;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "firstname")) {
                    return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm/firstname]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstname'.` };
                  }
                  const parsed_firstname = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm/firstname]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["firstname"]);
                  })();
                  if (!parsed_firstname.success) {
                    return { success: false, reason: parsed_firstname.reason };
                  }
                  if (!hasProp(value, "lastname")) {
                    return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm/lastname]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastname'.` };
                  }
                  const parsed_lastname = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/Demo1ValidatedForm/lastname]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["lastname"]);
                  })();
                  if (!parsed_lastname.success) {
                    return { success: false, reason: parsed_lastname.reason };
                  }
                  return { success: true, value: { firstname: parsed_firstname.value, lastname: parsed_lastname.value } };
                })(value);
              })(value["validatedForm"]);
            })();
            if (!parsed_validatedForm.success) {
              return { success: false, reason: parsed_validatedForm.reason };
            }
            return { success: true, value: { validatedForm: parsed_validatedForm.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "SUCCESS" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/Demo1ValidationResult]: '${discriminator}' expected to be one of 'ERROR, SUCCESS'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo2EditForm
export function serialize_Demo2EditForm(obj: Demo2EditForm): string {
  const serialized = ((value: { datefield: { year: number; month: number; day: number }; emailfield: string; numberfield: bigint; numbericfield: string; textfield: string }): unknown => {
    return {
      datefield: ((value: { year: number; month: number; day: number }): unknown => {
        return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
      })(value["datefield"]),
      emailfield: ((value: string): unknown => {
        return value;
      })(value["emailfield"]),
      numberfield: ((value: bigint): unknown => {
        return value;
      })(value["numberfield"]),
      numbericfield: ((value: string): unknown => {
        return value;
      })(value["numbericfield"]),
      textfield: ((value: string): unknown => {
        return value;
      })(value["textfield"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo2EditForm(str: string): ParserResult<Demo2EditForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    datefield: { year: number; month: number; day: number };
    emailfield: string;
    numberfield: bigint;
    numbericfield: string;
    textfield: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/Demo2EditForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/Demo2EditForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "datefield")) {
      return { success: false, reason: `[#/components/schemas/Demo2EditForm/datefield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'datefield'.` };
    }
    const parsed_datefield = ((): ParserResult<{ year: number; month: number; day: number }> => {
      return ((value: unknown): ParserResult<{ year: number; month: number; day: number }> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo2EditForm/datefield]: '${value}' expected to be of type string.` };
        }
        const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/Demo2EditForm/datefield]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
        }
        return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
      })(value["datefield"]);
    })();
    if (!parsed_datefield.success) {
      return { success: false, reason: parsed_datefield.reason };
    }
    if (!hasProp(value, "emailfield")) {
      return { success: false, reason: `[#/components/schemas/Demo2EditForm/emailfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'emailfield'.` };
    }
    const parsed_emailfield = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo2EditForm/emailfield]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["emailfield"]);
    })();
    if (!parsed_emailfield.success) {
      return { success: false, reason: parsed_emailfield.reason };
    }
    if (!hasProp(value, "numberfield")) {
      return { success: false, reason: `[#/components/schemas/Demo2EditForm/numberfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'numberfield'.` };
    }
    const parsed_numberfield = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/Demo2EditForm/numberfield]: '${value}' expected to be of type bigint or number.` };
      })(value["numberfield"]);
    })();
    if (!parsed_numberfield.success) {
      return { success: false, reason: parsed_numberfield.reason };
    }
    if (!hasProp(value, "numbericfield")) {
      return { success: false, reason: `[#/components/schemas/Demo2EditForm/numbericfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'numbericfield'.` };
    }
    const parsed_numbericfield = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo2EditForm/numbericfield]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["numbericfield"]);
    })();
    if (!parsed_numbericfield.success) {
      return { success: false, reason: parsed_numbericfield.reason };
    }
    if (!hasProp(value, "textfield")) {
      return { success: false, reason: `[#/components/schemas/Demo2EditForm/textfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'textfield'.` };
    }
    const parsed_textfield = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo2EditForm/textfield]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["textfield"]);
    })();
    if (!parsed_textfield.success) {
      return { success: false, reason: parsed_textfield.reason };
    }
    return { success: true, value: { datefield: parsed_datefield.value, emailfield: parsed_emailfield.value, numberfield: parsed_numberfield.value, numbericfield: parsed_numbericfield.value, textfield: parsed_textfield.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo2ValidatedForm
export function serialize_Demo2ValidatedForm(obj: Demo2ValidatedForm): string {
  const serialized = ((value: { datefield: { year: number; month: number; day: number }; emailfield: string; numberfield: bigint; numbericfield: string; textfield: string }): unknown => {
    return {
      datefield: ((value: { year: number; month: number; day: number }): unknown => {
        return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
      })(value["datefield"]),
      emailfield: ((value: string): unknown => {
        return value;
      })(value["emailfield"]),
      numberfield: ((value: bigint): unknown => {
        return value;
      })(value["numberfield"]),
      numbericfield: ((value: string): unknown => {
        return value;
      })(value["numbericfield"]),
      textfield: ((value: string): unknown => {
        return value;
      })(value["textfield"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo2ValidatedForm(str: string): ParserResult<Demo2ValidatedForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    datefield: { year: number; month: number; day: number };
    emailfield: string;
    numberfield: bigint;
    numbericfield: string;
    textfield: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "datefield")) {
      return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/datefield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'datefield'.` };
    }
    const parsed_datefield = ((): ParserResult<{ year: number; month: number; day: number }> => {
      return ((value: unknown): ParserResult<{ year: number; month: number; day: number }> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/datefield]: '${value}' expected to be of type string.` };
        }
        const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/datefield]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
        }
        return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
      })(value["datefield"]);
    })();
    if (!parsed_datefield.success) {
      return { success: false, reason: parsed_datefield.reason };
    }
    if (!hasProp(value, "emailfield")) {
      return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/emailfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'emailfield'.` };
    }
    const parsed_emailfield = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/emailfield]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["emailfield"]);
    })();
    if (!parsed_emailfield.success) {
      return { success: false, reason: parsed_emailfield.reason };
    }
    if (!hasProp(value, "numberfield")) {
      return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/numberfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'numberfield'.` };
    }
    const parsed_numberfield = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/numberfield]: '${value}' expected to be of type bigint or number.` };
      })(value["numberfield"]);
    })();
    if (!parsed_numberfield.success) {
      return { success: false, reason: parsed_numberfield.reason };
    }
    if (!hasProp(value, "numbericfield")) {
      return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/numbericfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'numbericfield'.` };
    }
    const parsed_numbericfield = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/numbericfield]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["numbericfield"]);
    })();
    if (!parsed_numbericfield.success) {
      return { success: false, reason: parsed_numbericfield.reason };
    }
    if (!hasProp(value, "textfield")) {
      return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/textfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'textfield'.` };
    }
    const parsed_textfield = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/textfield]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["textfield"]);
    })();
    if (!parsed_textfield.success) {
      return { success: false, reason: parsed_textfield.reason };
    }
    return { success: true, value: { datefield: parsed_datefield.value, emailfield: parsed_emailfield.value, numberfield: parsed_numberfield.value, numbericfield: parsed_numbericfield.value, textfield: parsed_textfield.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo2ValidationResult
export function serialize_Demo2ValidationResult(obj: Demo2ValidationResult): string {
  const serialized = ((value: { kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: Demo2ValidatedForm }): unknown => {
    switch (value.kind) {
      case "ERROR": {
        return {
          kind: "ERROR",
          reasons: ((value: { fields: { additionalProperties: Record<string, string[]> }; general: string[] }): unknown => {
            return {
              fields: ((value: { additionalProperties: Record<string, string[]> }): unknown => {
                const unordered_obj: Record<string, unknown> = {
                  ...Object.fromEntries(
                    Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
                      return [
                        propertyKey,
                        ((value: string[]): unknown => {
                          return value.map((value: string): unknown => {
                            return value;
                          });
                        })(propertyValue),
                      ];
                    }),
                  ),
                };
                return Object.keys(unordered_obj)
                  .sort()
                  .reduce(
                    (obj, key) => {
                      obj[key] = unordered_obj[key];
                      return obj;
                    },
                    {} as Record<string, unknown>,
                  );
              })(value["fields"]),
              general: ((value: string[]): unknown => {
                return value.map((value: string): unknown => {
                  return value;
                });
              })(value["general"]),
            };
          })(value["reasons"]),
        };
      }
      case "SUCCESS": {
        return {
          kind: "SUCCESS",
          validatedForm: ((value: { datefield: { year: number; month: number; day: number }; emailfield: string; numberfield: bigint; numbericfield: string; textfield: string }): unknown => {
            return {
              datefield: ((value: { year: number; month: number; day: number }): unknown => {
                return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
              })(value["datefield"]),
              emailfield: ((value: string): unknown => {
                return value;
              })(value["emailfield"]),
              numberfield: ((value: bigint): unknown => {
                return value;
              })(value["numberfield"]),
              numbericfield: ((value: string): unknown => {
                return value;
              })(value["numbericfield"]),
              textfield: ((value: string): unknown => {
                return value;
              })(value["textfield"]),
            };
          })(value["validatedForm"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo2ValidationResult(str: string): ParserResult<Demo2ValidationResult> {
  return ((value: unknown): ParserResult<{ kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: Demo2ValidatedForm }> => {
    return ((value: unknown): ParserResult<{ kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: Demo2ValidatedForm }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/Demo2ValidationResult]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/Demo2ValidationResult]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/Demo2ValidationResult]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/Demo2ValidationResult]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "ERROR": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            reasons: ValidationErrorReasons;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Demo2ValidationResult/ERROR]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Demo2ValidationResult/ERROR]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "reasons")) {
              return { success: false, reason: `[#/components/schemas/Demo2ValidationResult/ERROR/reasons]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reasons'.` };
            }
            const parsed_reasons = ((): ParserResult<ValidationErrorReasons> => {
              return ((value: unknown): ParserResult<ValidationErrorReasons> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  fields: { additionalProperties: Record<string, string[]> };
                  general: string[];
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "fields")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fields'.` };
                  }
                  const parsed_fields = ((): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                    return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to not be null.` };
                      }
                      const parsed_additionalProperties = ((): ParserResult<Record<string, string[]>> => {
                        const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string[]>] => {
                          return [
                            key,
                            ((value: unknown): ParserResult<string[]> => {
                              if (!isArray(value)) {
                                return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: '${value}' expected to be an array.` };
                              }
                              const parsed = value.map((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/additionalProperty]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              });
                              if (parsed.find((value) => !value.success) !== undefined) {
                                return {
                                  success: false,
                                  reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: Reason(s): '${parsed
                                    .filter((p) => !p.success)
                                    .map((p) => p.reason)
                                    .join(", ")}'.`,
                                };
                              }
                              return {
                                success: true,
                                value: parsed.map((entry) => {
                                  assert(entry.success == true);
                                  return entry.value;
                                }),
                              };
                            })(value),
                          ];
                        });
                        if (parsed.find(([_, value]) => !value.success) !== undefined) {
                          return {
                            success: false,
                            reason: `[#/components/schemas/ValidationErrorReasons/fields]: Reason(s): '${parsed
                              .map(([_, value]) => value)
                              .filter((p) => !p.success)
                              .map((p) => p.reason)
                              .join(", ")}'.`,
                          };
                        }
                        return {
                          success: true,
                          value: Object.fromEntries(
                            parsed.map(([key, value]) => {
                              assert(value.success);
                              return [key, value.value];
                            }),
                          ),
                        };
                      })();
                      if (!parsed_additionalProperties.success) {
                        return { success: false, reason: parsed_additionalProperties.reason };
                      }
                      return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
                    })(value["fields"]);
                  })();
                  if (!parsed_fields.success) {
                    return { success: false, reason: parsed_fields.reason };
                  }
                  if (!hasProp(value, "general")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'general'.` };
                  }
                  const parsed_general = ((): ParserResult<string[]> => {
                    return ((value: unknown): ParserResult<string[]> => {
                      if (!isArray(value)) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be an array.` };
                      }
                      const parsed = value.map((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      });
                      if (parsed.find((value) => !value.success) !== undefined) {
                        return {
                          success: false,
                          reason: `[#/components/schemas/ValidationErrorReasons/general]: Reason(s): '${parsed
                            .filter((p) => !p.success)
                            .map((p) => p.reason)
                            .join(", ")}'.`,
                        };
                      }
                      return {
                        success: true,
                        value: parsed.map((entry) => {
                          assert(entry.success == true);
                          return entry.value;
                        }),
                      };
                    })(value["general"]);
                  })();
                  if (!parsed_general.success) {
                    return { success: false, reason: parsed_general.reason };
                  }
                  return { success: true, value: { fields: parsed_fields.value, general: parsed_general.value } };
                })(value);
              })(value["reasons"]);
            })();
            if (!parsed_reasons.success) {
              return { success: false, reason: parsed_reasons.reason };
            }
            return { success: true, value: { reasons: parsed_reasons.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "ERROR" as const, ...parsedVariant.value } };
        }
        case "SUCCESS": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            validatedForm: Demo2ValidatedForm;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Demo2ValidationResult/SUCCESS]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Demo2ValidationResult/SUCCESS]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "validatedForm")) {
              return { success: false, reason: `[#/components/schemas/Demo2ValidationResult/SUCCESS/validatedForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'validatedForm'.` };
            }
            const parsed_validatedForm = ((): ParserResult<Demo2ValidatedForm> => {
              return ((value: unknown): ParserResult<Demo2ValidatedForm> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  datefield: { year: number; month: number; day: number };
                  emailfield: string;
                  numberfield: bigint;
                  numbericfield: string;
                  textfield: string;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "datefield")) {
                    return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/datefield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'datefield'.` };
                  }
                  const parsed_datefield = ((): ParserResult<{ year: number; month: number; day: number }> => {
                    return ((value: unknown): ParserResult<{ year: number; month: number; day: number }> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/datefield]: '${value}' expected to be of type string.` };
                      }
                      const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
                      if (!parsed.isValid) {
                        return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/datefield]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
                      }
                      return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
                    })(value["datefield"]);
                  })();
                  if (!parsed_datefield.success) {
                    return { success: false, reason: parsed_datefield.reason };
                  }
                  if (!hasProp(value, "emailfield")) {
                    return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/emailfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'emailfield'.` };
                  }
                  const parsed_emailfield = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/emailfield]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["emailfield"]);
                  })();
                  if (!parsed_emailfield.success) {
                    return { success: false, reason: parsed_emailfield.reason };
                  }
                  if (!hasProp(value, "numberfield")) {
                    return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/numberfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'numberfield'.` };
                  }
                  const parsed_numberfield = ((): ParserResult<bigint> => {
                    return ((value: unknown): ParserResult<bigint> => {
                      if (typeof value === "number") {
                        return { success: true, value: BigInt(value) };
                      }
                      if (typeof value === "bigint") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/numberfield]: '${value}' expected to be of type bigint or number.` };
                    })(value["numberfield"]);
                  })();
                  if (!parsed_numberfield.success) {
                    return { success: false, reason: parsed_numberfield.reason };
                  }
                  if (!hasProp(value, "numbericfield")) {
                    return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/numbericfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'numbericfield'.` };
                  }
                  const parsed_numbericfield = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/numbericfield]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["numbericfield"]);
                  })();
                  if (!parsed_numbericfield.success) {
                    return { success: false, reason: parsed_numbericfield.reason };
                  }
                  if (!hasProp(value, "textfield")) {
                    return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/textfield]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'textfield'.` };
                  }
                  const parsed_textfield = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/Demo2ValidatedForm/textfield]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["textfield"]);
                  })();
                  if (!parsed_textfield.success) {
                    return { success: false, reason: parsed_textfield.reason };
                  }
                  return {
                    success: true,
                    value: { datefield: parsed_datefield.value, emailfield: parsed_emailfield.value, numberfield: parsed_numberfield.value, numbericfield: parsed_numbericfield.value, textfield: parsed_textfield.value },
                  };
                })(value);
              })(value["validatedForm"]);
            })();
            if (!parsed_validatedForm.success) {
              return { success: false, reason: parsed_validatedForm.reason };
            }
            return { success: true, value: { validatedForm: parsed_validatedForm.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "SUCCESS" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/Demo2ValidationResult]: '${discriminator}' expected to be one of 'ERROR, SUCCESS'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo7EditForm
export function serialize_Demo7EditForm(obj: Demo7EditForm): string {
  const serialized = ((value: { agb: boolean }): unknown => {
    return {
      agb: ((value: boolean): unknown => {
        return value;
      })(value["agb"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo7EditForm(str: string): ParserResult<Demo7EditForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    agb: boolean;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/Demo7EditForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/Demo7EditForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "agb")) {
      return { success: false, reason: `[#/components/schemas/Demo7EditForm/agb]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'agb'.` };
    }
    const parsed_agb = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/Demo7EditForm/agb]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["agb"]);
    })();
    if (!parsed_agb.success) {
      return { success: false, reason: parsed_agb.reason };
    }
    return { success: true, value: { agb: parsed_agb.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo7ValidatedForm
export function serialize_Demo7ValidatedForm(obj: Demo7ValidatedForm): string {
  const serialized = ((value: { agb: boolean }): unknown => {
    return {
      agb: ((value: boolean): unknown => {
        return value;
      })(value["agb"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo7ValidatedForm(str: string): ParserResult<Demo7ValidatedForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    agb: boolean;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/Demo7ValidatedForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/Demo7ValidatedForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "agb")) {
      return { success: false, reason: `[#/components/schemas/Demo7ValidatedForm/agb]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'agb'.` };
    }
    const parsed_agb = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/Demo7ValidatedForm/agb]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["agb"]);
    })();
    if (!parsed_agb.success) {
      return { success: false, reason: parsed_agb.reason };
    }
    return { success: true, value: { agb: parsed_agb.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// Demo7ValidationResult
export function serialize_Demo7ValidationResult(obj: Demo7ValidationResult): string {
  const serialized = ((value: { kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: Demo7ValidatedForm }): unknown => {
    switch (value.kind) {
      case "ERROR": {
        return {
          kind: "ERROR",
          reasons: ((value: { fields: { additionalProperties: Record<string, string[]> }; general: string[] }): unknown => {
            return {
              fields: ((value: { additionalProperties: Record<string, string[]> }): unknown => {
                const unordered_obj: Record<string, unknown> = {
                  ...Object.fromEntries(
                    Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
                      return [
                        propertyKey,
                        ((value: string[]): unknown => {
                          return value.map((value: string): unknown => {
                            return value;
                          });
                        })(propertyValue),
                      ];
                    }),
                  ),
                };
                return Object.keys(unordered_obj)
                  .sort()
                  .reduce(
                    (obj, key) => {
                      obj[key] = unordered_obj[key];
                      return obj;
                    },
                    {} as Record<string, unknown>,
                  );
              })(value["fields"]),
              general: ((value: string[]): unknown => {
                return value.map((value: string): unknown => {
                  return value;
                });
              })(value["general"]),
            };
          })(value["reasons"]),
        };
      }
      case "SUCCESS": {
        return {
          kind: "SUCCESS",
          validatedForm: ((value: { agb: boolean }): unknown => {
            return {
              agb: ((value: boolean): unknown => {
                return value;
              })(value["agb"]),
            };
          })(value["validatedForm"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Demo7ValidationResult(str: string): ParserResult<Demo7ValidationResult> {
  return ((value: unknown): ParserResult<{ kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: Demo7ValidatedForm }> => {
    return ((value: unknown): ParserResult<{ kind: "ERROR"; reasons: ValidationErrorReasons } | { kind: "SUCCESS"; validatedForm: Demo7ValidatedForm }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/Demo7ValidationResult]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/Demo7ValidationResult]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/Demo7ValidationResult]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/Demo7ValidationResult]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "ERROR": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            reasons: ValidationErrorReasons;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Demo7ValidationResult/ERROR]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Demo7ValidationResult/ERROR]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "reasons")) {
              return { success: false, reason: `[#/components/schemas/Demo7ValidationResult/ERROR/reasons]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reasons'.` };
            }
            const parsed_reasons = ((): ParserResult<ValidationErrorReasons> => {
              return ((value: unknown): ParserResult<ValidationErrorReasons> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  fields: { additionalProperties: Record<string, string[]> };
                  general: string[];
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "fields")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fields'.` };
                  }
                  const parsed_fields = ((): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                    return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to not be null.` };
                      }
                      const parsed_additionalProperties = ((): ParserResult<Record<string, string[]>> => {
                        const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string[]>] => {
                          return [
                            key,
                            ((value: unknown): ParserResult<string[]> => {
                              if (!isArray(value)) {
                                return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: '${value}' expected to be an array.` };
                              }
                              const parsed = value.map((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/additionalProperty]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              });
                              if (parsed.find((value) => !value.success) !== undefined) {
                                return {
                                  success: false,
                                  reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: Reason(s): '${parsed
                                    .filter((p) => !p.success)
                                    .map((p) => p.reason)
                                    .join(", ")}'.`,
                                };
                              }
                              return {
                                success: true,
                                value: parsed.map((entry) => {
                                  assert(entry.success == true);
                                  return entry.value;
                                }),
                              };
                            })(value),
                          ];
                        });
                        if (parsed.find(([_, value]) => !value.success) !== undefined) {
                          return {
                            success: false,
                            reason: `[#/components/schemas/ValidationErrorReasons/fields]: Reason(s): '${parsed
                              .map(([_, value]) => value)
                              .filter((p) => !p.success)
                              .map((p) => p.reason)
                              .join(", ")}'.`,
                          };
                        }
                        return {
                          success: true,
                          value: Object.fromEntries(
                            parsed.map(([key, value]) => {
                              assert(value.success);
                              return [key, value.value];
                            }),
                          ),
                        };
                      })();
                      if (!parsed_additionalProperties.success) {
                        return { success: false, reason: parsed_additionalProperties.reason };
                      }
                      return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
                    })(value["fields"]);
                  })();
                  if (!parsed_fields.success) {
                    return { success: false, reason: parsed_fields.reason };
                  }
                  if (!hasProp(value, "general")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'general'.` };
                  }
                  const parsed_general = ((): ParserResult<string[]> => {
                    return ((value: unknown): ParserResult<string[]> => {
                      if (!isArray(value)) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be an array.` };
                      }
                      const parsed = value.map((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      });
                      if (parsed.find((value) => !value.success) !== undefined) {
                        return {
                          success: false,
                          reason: `[#/components/schemas/ValidationErrorReasons/general]: Reason(s): '${parsed
                            .filter((p) => !p.success)
                            .map((p) => p.reason)
                            .join(", ")}'.`,
                        };
                      }
                      return {
                        success: true,
                        value: parsed.map((entry) => {
                          assert(entry.success == true);
                          return entry.value;
                        }),
                      };
                    })(value["general"]);
                  })();
                  if (!parsed_general.success) {
                    return { success: false, reason: parsed_general.reason };
                  }
                  return { success: true, value: { fields: parsed_fields.value, general: parsed_general.value } };
                })(value);
              })(value["reasons"]);
            })();
            if (!parsed_reasons.success) {
              return { success: false, reason: parsed_reasons.reason };
            }
            return { success: true, value: { reasons: parsed_reasons.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "ERROR" as const, ...parsedVariant.value } };
        }
        case "SUCCESS": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            validatedForm: Demo7ValidatedForm;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Demo7ValidationResult/SUCCESS]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Demo7ValidationResult/SUCCESS]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "validatedForm")) {
              return { success: false, reason: `[#/components/schemas/Demo7ValidationResult/SUCCESS/validatedForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'validatedForm'.` };
            }
            const parsed_validatedForm = ((): ParserResult<Demo7ValidatedForm> => {
              return ((value: unknown): ParserResult<Demo7ValidatedForm> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  agb: boolean;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/Demo7ValidatedForm]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/Demo7ValidatedForm]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "agb")) {
                    return { success: false, reason: `[#/components/schemas/Demo7ValidatedForm/agb]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'agb'.` };
                  }
                  const parsed_agb = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/Demo7ValidatedForm/agb]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["agb"]);
                  })();
                  if (!parsed_agb.success) {
                    return { success: false, reason: parsed_agb.reason };
                  }
                  return { success: true, value: { agb: parsed_agb.value } };
                })(value);
              })(value["validatedForm"]);
            })();
            if (!parsed_validatedForm.success) {
              return { success: false, reason: parsed_validatedForm.reason };
            }
            return { success: true, value: { validatedForm: parsed_validatedForm.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "SUCCESS" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/Demo7ValidationResult]: '${discriminator}' expected to be one of 'ERROR, SUCCESS'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// EmptyObjectExample
export function serialize_EmptyObjectExample(obj: EmptyObjectExample): string {
  const serialized = ((value: { schema?: any }): unknown => {
    return {
      schema: ((value: any | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["schema"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_EmptyObjectExample(str: string): ParserResult<EmptyObjectExample> {
  return ((
    value: unknown,
  ): ParserResult<{
    schema?: any;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/EmptyObjectExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/EmptyObjectExample]: '${value}' expected to not be null.` };
    }
    const parsed_schema = ((): ParserResult<any | undefined> => {
      if (!hasProp(value, "schema")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<any | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        return { success: true, value: value };
      })(value["schema"]);
    })();
    if (!parsed_schema.success) {
      return { success: false, reason: parsed_schema.reason };
    }
    return { success: true, value: { schema: parsed_schema.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// ExampleEnum
export function serialize_ExampleEnum(obj: ExampleEnum): string {
  const serialized = ((value: "FOO" | "BAR"): unknown => {
    return value;
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ExampleEnum(str: string): ParserResult<ExampleEnum> {
  return ((value: unknown): ParserResult<"FOO" | "BAR"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/ExampleEnum]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "FOO":
        return { success: true, value: "FOO" };
      case "BAR":
        return { success: true, value: "BAR" };
      default:
        return { success: false, reason: `[#/components/schemas/ExampleEnum]: '${value}' expected to be enum, one of 'FOO, BAR'.` };
    }
  })(parseJsonWithNumbersAsBigint(str));
}

// ExperimentModel
export function serialize_ExperimentModel(obj: ExperimentModel): string {
  const serialized = ((value: {
    booleanExample: boolean;
    booleanNullableExample: boolean | null;
    doubleExample: number;
    doubleNullableExample: number | null;
    floatExample: number;
    floatNullableExample: number | null;
    intExample: number;
    intNullableExample: number | null;
    longExample: bigint;
    longNullableExample: bigint | null;
    stringExample: string;
    stringNullableExample: string | null;
  }): unknown => {
    return {
      booleanExample: ((value: boolean): unknown => {
        return value;
      })(value["booleanExample"]),
      booleanNullableExample: ((value: boolean | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["booleanNullableExample"]),
      doubleExample: ((value: number): unknown => {
        return value;
      })(value["doubleExample"]),
      doubleNullableExample: ((value: number | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["doubleNullableExample"]),
      floatExample: ((value: number): unknown => {
        return value;
      })(value["floatExample"]),
      floatNullableExample: ((value: number | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["floatNullableExample"]),
      intExample: ((value: number): unknown => {
        return value;
      })(value["intExample"]),
      intNullableExample: ((value: number | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["intNullableExample"]),
      longExample: ((value: bigint): unknown => {
        return value;
      })(value["longExample"]),
      longNullableExample: ((value: bigint | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["longNullableExample"]),
      stringExample: ((value: string): unknown => {
        return value;
      })(value["stringExample"]),
      stringNullableExample: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["stringNullableExample"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ExperimentModel(str: string): ParserResult<ExperimentModel> {
  return ((
    value: unknown,
  ): ParserResult<{
    booleanExample: boolean;
    booleanNullableExample: boolean | null;
    doubleExample: number;
    doubleNullableExample: number | null;
    floatExample: number;
    floatNullableExample: number | null;
    intExample: number;
    intNullableExample: number | null;
    longExample: bigint;
    longNullableExample: bigint | null;
    stringExample: string;
    stringNullableExample: string | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ExperimentModel]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "booleanExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/booleanExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'booleanExample'.` };
    }
    const parsed_booleanExample = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/ExperimentModel/booleanExample]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["booleanExample"]);
    })();
    if (!parsed_booleanExample.success) {
      return { success: false, reason: parsed_booleanExample.reason };
    }
    if (!hasProp(value, "booleanNullableExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/booleanNullableExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'booleanNullableExample'.` };
    }
    const parsed_booleanNullableExample = ((): ParserResult<boolean | null> => {
      return ((value: unknown): ParserResult<boolean | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/ExperimentModel/booleanNullableExample]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["booleanNullableExample"]);
    })();
    if (!parsed_booleanNullableExample.success) {
      return { success: false, reason: parsed_booleanNullableExample.reason };
    }
    if (!hasProp(value, "doubleExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/doubleExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'doubleExample'.` };
    }
    const parsed_doubleExample = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        if (typeof value === "bigint") {
          return { success: true, value: Number(value) };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentModel/doubleExample]: '${value}' expected to be of type number or bigint.` };
      })(value["doubleExample"]);
    })();
    if (!parsed_doubleExample.success) {
      return { success: false, reason: parsed_doubleExample.reason };
    }
    if (!hasProp(value, "doubleNullableExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/doubleNullableExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'doubleNullableExample'.` };
    }
    const parsed_doubleNullableExample = ((): ParserResult<number | null> => {
      return ((value: unknown): ParserResult<number | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        if (typeof value === "bigint") {
          return { success: true, value: Number(value) };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentModel/doubleNullableExample]: '${value}' expected to be of type number or bigint.` };
      })(value["doubleNullableExample"]);
    })();
    if (!parsed_doubleNullableExample.success) {
      return { success: false, reason: parsed_doubleNullableExample.reason };
    }
    if (!hasProp(value, "floatExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/floatExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'floatExample'.` };
    }
    const parsed_floatExample = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        if (typeof value === "bigint") {
          return { success: true, value: Number(value) };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentModel/floatExample]: '${value}' expected to be of type number or bigint.` };
      })(value["floatExample"]);
    })();
    if (!parsed_floatExample.success) {
      return { success: false, reason: parsed_floatExample.reason };
    }
    if (!hasProp(value, "floatNullableExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/floatNullableExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'floatNullableExample'.` };
    }
    const parsed_floatNullableExample = ((): ParserResult<number | null> => {
      return ((value: unknown): ParserResult<number | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        if (typeof value === "bigint") {
          return { success: true, value: Number(value) };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentModel/floatNullableExample]: '${value}' expected to be of type number or bigint.` };
      })(value["floatNullableExample"]);
    })();
    if (!parsed_floatNullableExample.success) {
      return { success: false, reason: parsed_floatNullableExample.reason };
    }
    if (!hasProp(value, "intExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/intExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intExample'.` };
    }
    const parsed_intExample = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentModel/intExample]: '${value}' expected to be of type number.` };
      })(value["intExample"]);
    })();
    if (!parsed_intExample.success) {
      return { success: false, reason: parsed_intExample.reason };
    }
    if (!hasProp(value, "intNullableExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/intNullableExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intNullableExample'.` };
    }
    const parsed_intNullableExample = ((): ParserResult<number | null> => {
      return ((value: unknown): ParserResult<number | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentModel/intNullableExample]: '${value}' expected to be of type number.` };
      })(value["intNullableExample"]);
    })();
    if (!parsed_intNullableExample.success) {
      return { success: false, reason: parsed_intNullableExample.reason };
    }
    if (!hasProp(value, "longExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/longExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'longExample'.` };
    }
    const parsed_longExample = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentModel/longExample]: '${value}' expected to be of type bigint or number.` };
      })(value["longExample"]);
    })();
    if (!parsed_longExample.success) {
      return { success: false, reason: parsed_longExample.reason };
    }
    if (!hasProp(value, "longNullableExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/longNullableExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'longNullableExample'.` };
    }
    const parsed_longNullableExample = ((): ParserResult<bigint | null> => {
      return ((value: unknown): ParserResult<bigint | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentModel/longNullableExample]: '${value}' expected to be of type bigint or number.` };
      })(value["longNullableExample"]);
    })();
    if (!parsed_longNullableExample.success) {
      return { success: false, reason: parsed_longNullableExample.reason };
    }
    if (!hasProp(value, "stringExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/stringExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'stringExample'.` };
    }
    const parsed_stringExample = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExperimentModel/stringExample]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["stringExample"]);
    })();
    if (!parsed_stringExample.success) {
      return { success: false, reason: parsed_stringExample.reason };
    }
    if (!hasProp(value, "stringNullableExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentModel/stringNullableExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'stringNullableExample'.` };
    }
    const parsed_stringNullableExample = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExperimentModel/stringNullableExample]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["stringNullableExample"]);
    })();
    if (!parsed_stringNullableExample.success) {
      return { success: false, reason: parsed_stringNullableExample.reason };
    }
    return {
      success: true,
      value: {
        booleanExample: parsed_booleanExample.value,
        booleanNullableExample: parsed_booleanNullableExample.value,
        doubleExample: parsed_doubleExample.value,
        doubleNullableExample: parsed_doubleNullableExample.value,
        floatExample: parsed_floatExample.value,
        floatNullableExample: parsed_floatNullableExample.value,
        intExample: parsed_intExample.value,
        intNullableExample: parsed_intNullableExample.value,
        longExample: parsed_longExample.value,
        longNullableExample: parsed_longNullableExample.value,
        stringExample: parsed_stringExample.value,
        stringNullableExample: parsed_stringNullableExample.value,
      },
    };
  })(parseJsonWithNumbersAsBigint(str));
}

// ExperimentOptionalModel
export function serialize_ExperimentOptionalModel(obj: ExperimentOptionalModel): string {
  const serialized = ((value: { intExample: number; intNullableExample: number | null; intOptionalExample?: number; intOptionalNullableExample?: number | null }): unknown => {
    return {
      intExample: ((value: number): unknown => {
        return value;
      })(value["intExample"]),
      intNullableExample: ((value: number | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["intNullableExample"]),
      intOptionalExample: ((value: number | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["intOptionalExample"]),
      intOptionalNullableExample: ((value: number | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value;
      })(value["intOptionalNullableExample"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ExperimentOptionalModel(str: string): ParserResult<ExperimentOptionalModel> {
  return ((
    value: unknown,
  ): ParserResult<{
    intExample: number;
    intNullableExample: number | null;
    intOptionalExample?: number;
    intOptionalNullableExample?: number | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ExperimentOptionalModel]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ExperimentOptionalModel]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "intExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentOptionalModel/intExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intExample'.` };
    }
    const parsed_intExample = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentOptionalModel/intExample]: '${value}' expected to be of type number.` };
      })(value["intExample"]);
    })();
    if (!parsed_intExample.success) {
      return { success: false, reason: parsed_intExample.reason };
    }
    if (!hasProp(value, "intNullableExample")) {
      return { success: false, reason: `[#/components/schemas/ExperimentOptionalModel/intNullableExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intNullableExample'.` };
    }
    const parsed_intNullableExample = ((): ParserResult<number | null> => {
      return ((value: unknown): ParserResult<number | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentOptionalModel/intNullableExample]: '${value}' expected to be of type number.` };
      })(value["intNullableExample"]);
    })();
    if (!parsed_intNullableExample.success) {
      return { success: false, reason: parsed_intNullableExample.reason };
    }
    const parsed_intOptionalExample = ((): ParserResult<number | undefined> => {
      if (!hasProp(value, "intOptionalExample")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<number | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentOptionalModel/intOptionalExample]: '${value}' expected to be of type number.` };
      })(value["intOptionalExample"]);
    })();
    if (!parsed_intOptionalExample.success) {
      return { success: false, reason: parsed_intOptionalExample.reason };
    }
    const parsed_intOptionalNullableExample = ((): ParserResult<number | null | undefined> => {
      if (!hasProp(value, "intOptionalNullableExample")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<number | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExperimentOptionalModel/intOptionalNullableExample]: '${value}' expected to be of type number.` };
      })(value["intOptionalNullableExample"]);
    })();
    if (!parsed_intOptionalNullableExample.success) {
      return { success: false, reason: parsed_intOptionalNullableExample.reason };
    }
    return {
      success: true,
      value: { intExample: parsed_intExample.value, intNullableExample: parsed_intNullableExample.value, intOptionalExample: parsed_intOptionalExample.value, intOptionalNullableExample: parsed_intOptionalNullableExample.value },
    };
  })(parseJsonWithNumbersAsBigint(str));
}

// ExperimentRefModel
export function serialize_ExperimentRefModel(obj: ExperimentRefModel): string {
  const serialized = ((value: {
    nullableSubModel: SubModel | null;
    subComponent: {
      intValue: number;
    };
    subModel: SubModel;
  }): unknown => {
    return {
      nullableSubModel: ((
        value: {
          intValue: number;
        } | null,
      ): unknown => {
        if (value === null) {
          return null;
        }
        return {
          intValue: ((value: number): unknown => {
            return value;
          })(value["intValue"]),
        };
      })(value["nullableSubModel"]),
      subComponent: ((value: { intValue: number }): unknown => {
        return {
          intValue: ((value: number): unknown => {
            return value;
          })(value["intValue"]),
        };
      })(value["subComponent"]),
      subModel: ((value: { intValue: number }): unknown => {
        return {
          intValue: ((value: number): unknown => {
            return value;
          })(value["intValue"]),
        };
      })(value["subModel"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ExperimentRefModel(str: string): ParserResult<ExperimentRefModel> {
  return ((
    value: unknown,
  ): ParserResult<{
    nullableSubModel: SubModel | null;
    subComponent: {
      intValue: number;
    };
    subModel: SubModel;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ExperimentRefModel]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ExperimentRefModel]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "nullableSubModel")) {
      return { success: false, reason: `[#/components/schemas/ExperimentRefModel/nullableSubModel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'nullableSubModel'.` };
    }
    const parsed_nullableSubModel = ((): ParserResult<SubModel | null> => {
      return ((value: unknown): ParserResult<SubModel | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return ((
          value: unknown,
        ): ParserResult<{
          intValue: number;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "intValue")) {
            return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
          }
          const parsed_intValue = ((): ParserResult<number> => {
            return ((value: unknown): ParserResult<number> => {
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${value}' expected to be of type number.` };
            })(value["intValue"]);
          })();
          if (!parsed_intValue.success) {
            return { success: false, reason: parsed_intValue.reason };
          }
          return { success: true, value: { intValue: parsed_intValue.value } };
        })(value);
      })(value["nullableSubModel"]);
    })();
    if (!parsed_nullableSubModel.success) {
      return { success: false, reason: parsed_nullableSubModel.reason };
    }
    if (!hasProp(value, "subComponent")) {
      return { success: false, reason: `[#/components/schemas/ExperimentRefModel/subComponent]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subComponent'.` };
    }
    const parsed_subComponent = ((): ParserResult<{
      intValue: number;
    }> => {
      return ((
        value: unknown,
      ): ParserResult<{
        intValue: number;
      }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/ExperimentRefModel/subComponent]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/ExperimentRefModel/subComponent]: '${value}' expected to not be null.` };
        }
        if (!hasProp(value, "intValue")) {
          return { success: false, reason: `[#/components/schemas/ExperimentRefModel/subComponent/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
        }
        const parsed_intValue = ((): ParserResult<number> => {
          return ((value: unknown): ParserResult<number> => {
            if (typeof value === "number") {
              return { success: true, value: value };
            }
            return { success: false, reason: `[#/components/schemas/ExperimentRefModel/subComponent/intValue]: '${value}' expected to be of type number.` };
          })(value["intValue"]);
        })();
        if (!parsed_intValue.success) {
          return { success: false, reason: parsed_intValue.reason };
        }
        return { success: true, value: { intValue: parsed_intValue.value } };
      })(value["subComponent"]);
    })();
    if (!parsed_subComponent.success) {
      return { success: false, reason: parsed_subComponent.reason };
    }
    if (!hasProp(value, "subModel")) {
      return { success: false, reason: `[#/components/schemas/ExperimentRefModel/subModel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subModel'.` };
    }
    const parsed_subModel = ((): ParserResult<SubModel> => {
      return ((value: unknown): ParserResult<SubModel> => {
        return ((
          value: unknown,
        ): ParserResult<{
          intValue: number;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "intValue")) {
            return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
          }
          const parsed_intValue = ((): ParserResult<number> => {
            return ((value: unknown): ParserResult<number> => {
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${value}' expected to be of type number.` };
            })(value["intValue"]);
          })();
          if (!parsed_intValue.success) {
            return { success: false, reason: parsed_intValue.reason };
          }
          return { success: true, value: { intValue: parsed_intValue.value } };
        })(value);
      })(value["subModel"]);
    })();
    if (!parsed_subModel.success) {
      return { success: false, reason: parsed_subModel.reason };
    }
    return { success: true, value: { nullableSubModel: parsed_nullableSubModel.value, subComponent: parsed_subComponent.value, subModel: parsed_subModel.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// ExperimentalDemoModel
export function serialize_ExperimentalDemoModel(obj: ExperimentalDemoModel): string {
  const serialized = ((value: { text: string }): unknown => {
    return {
      text: ((value: string): unknown => {
        return value;
      })(value["text"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ExperimentalDemoModel(str: string): ParserResult<ExperimentalDemoModel> {
  return ((
    value: unknown,
  ): ParserResult<{
    text: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ExperimentalDemoModel]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ExperimentalDemoModel]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "text")) {
      return { success: false, reason: `[#/components/schemas/ExperimentalDemoModel/text]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'text'.` };
    }
    const parsed_text = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExperimentalDemoModel/text]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["text"]);
    })();
    if (!parsed_text.success) {
      return { success: false, reason: parsed_text.reason };
    }
    return { success: true, value: { text: parsed_text.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// ExternalTypeExample
export function serialize_ExternalTypeExample(obj: ExternalTypeExample): string {
  const serialized = ((value: { typed?: ("IBAN" | "ABA" | "SWIFTBIC" | "CHEQUE") | null; untyped?: string | null }): unknown => {
    return {
      typed: ((value: ("IBAN" | "ABA" | "SWIFTBIC" | "CHEQUE") | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value;
      })(value["typed"]),
      untyped: ((value: string | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value;
      })(value["untyped"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ExternalTypeExample(str: string): ParserResult<ExternalTypeExample> {
  return ((
    value: unknown,
  ): ParserResult<{
    typed?: ("IBAN" | "ABA" | "SWIFTBIC" | "CHEQUE") | null;
    untyped?: string | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ExternalTypeExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ExternalTypeExample]: '${value}' expected to not be null.` };
    }
    const parsed_typed = ((): ParserResult<("IBAN" | "ABA" | "SWIFTBIC" | "CHEQUE") | null | undefined> => {
      if (!hasProp(value, "typed")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<("IBAN" | "ABA" | "SWIFTBIC" | "CHEQUE") | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExternalTypeExample/typed]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "IBAN":
            return { success: true, value: "IBAN" };
          case "ABA":
            return { success: true, value: "ABA" };
          case "SWIFTBIC":
            return { success: true, value: "SWIFTBIC" };
          case "CHEQUE":
            return { success: true, value: "CHEQUE" };
          default:
            return { success: false, reason: `[#/components/schemas/ExternalTypeExample/typed]: '${value}' expected to be enum, one of 'IBAN, ABA, SWIFTBIC, CHEQUE'.` };
        }
      })(value["typed"]);
    })();
    if (!parsed_typed.success) {
      return { success: false, reason: parsed_typed.reason };
    }
    const parsed_untyped = ((): ParserResult<string | null | undefined> => {
      if (!hasProp(value, "untyped")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExternalTypeExample/untyped]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["untyped"]);
    })();
    if (!parsed_untyped.success) {
      return { success: false, reason: parsed_untyped.reason };
    }
    return { success: true, value: { typed: parsed_typed.value, untyped: parsed_untyped.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// NamedEnumInArr
export function serialize_NamedEnumInArr(obj: NamedEnumInArr): string {
  const serialized = ((value: { arr?: ExampleEnum[] }): unknown => {
    return {
      arr: ((value: ExampleEnum[] | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value.map((value: "FOO" | "BAR"): unknown => {
          return value;
        });
      })(value["arr"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_NamedEnumInArr(str: string): ParserResult<NamedEnumInArr> {
  return ((
    value: unknown,
  ): ParserResult<{
    arr?: ExampleEnum[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/NamedEnumInArr]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/NamedEnumInArr]: '${value}' expected to not be null.` };
    }
    const parsed_arr = ((): ParserResult<ExampleEnum[] | undefined> => {
      if (!hasProp(value, "arr")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<ExampleEnum[] | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/NamedEnumInArr/arr]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<ExampleEnum> => {
          return ((value: unknown): ParserResult<"FOO" | "BAR"> => {
            if (typeof value !== "string") {
              return { success: false, reason: `[#/components/schemas/ExampleEnum]: '${value}' expected to be of type string.` };
            }
            switch (value) {
              case "FOO":
                return { success: true, value: "FOO" };
              case "BAR":
                return { success: true, value: "BAR" };
              default:
                return { success: false, reason: `[#/components/schemas/ExampleEnum]: '${value}' expected to be enum, one of 'FOO, BAR'.` };
            }
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/NamedEnumInArr/arr]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr"]);
    })();
    if (!parsed_arr.success) {
      return { success: false, reason: parsed_arr.reason };
    }
    return { success: true, value: { arr: parsed_arr.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// NamedEnumInObj
export function serialize_NamedEnumInObj(obj: NamedEnumInObj): string {
  const serialized = ((value: { value?: ExampleEnum }): unknown => {
    return {
      value: ((value: ("FOO" | "BAR") | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["value"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_NamedEnumInObj(str: string): ParserResult<NamedEnumInObj> {
  return ((
    value: unknown,
  ): ParserResult<{
    value?: ExampleEnum;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/NamedEnumInObj]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/NamedEnumInObj]: '${value}' expected to not be null.` };
    }
    const parsed_value = ((): ParserResult<ExampleEnum | undefined> => {
      if (!hasProp(value, "value")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<ExampleEnum | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        return ((value: unknown): ParserResult<"FOO" | "BAR"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/ExampleEnum]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "FOO":
              return { success: true, value: "FOO" };
            case "BAR":
              return { success: true, value: "BAR" };
            default:
              return { success: false, reason: `[#/components/schemas/ExampleEnum]: '${value}' expected to be enum, one of 'FOO, BAR'.` };
          }
        })(value);
      })(value["value"]);
    })();
    if (!parsed_value.success) {
      return { success: false, reason: parsed_value.reason };
    }
    return { success: true, value: { value: parsed_value.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// NamingEdgecases
export function serialize_NamingEdgecases(obj: NamingEdgecases): string {
  const serialized = ((value: { "a."?: string; "a.b"?: "" | "a.c" | "b." | "c$" | "d'" | 'e"'; b$?: string; "c?"?: string }): unknown => {
    return {
      "a.": ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["a."]),
      "a.b": ((value: ("" | "a.c" | "b." | "c$" | "d'" | 'e"') | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["a.b"]),
      b$: ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["b$"]),
      "c?": ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["c?"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_NamingEdgecases(str: string): ParserResult<NamingEdgecases> {
  return ((
    value: unknown,
  ): ParserResult<{
    "a."?: string;
    "a.b"?: "" | "a.c" | "b." | "c$" | "d'" | 'e"';
    b$?: string;
    "c?"?: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/NamingEdgecases]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/NamingEdgecases]: '${value}' expected to not be null.` };
    }
    const parsed_a_ = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "a.")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NamingEdgecases/a.]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["a."]);
    })();
    if (!parsed_a_.success) {
      return { success: false, reason: parsed_a_.reason };
    }
    const parsed_a_b = ((): ParserResult<("" | "a.c" | "b." | "c$" | "d'" | 'e"') | undefined> => {
      if (!hasProp(value, "a.b")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<("" | "a.c" | "b." | "c$" | "d'" | 'e"') | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NamingEdgecases/a.b]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "":
            return { success: true, value: "" };
          case "a.c":
            return { success: true, value: "a.c" };
          case "b.":
            return { success: true, value: "b." };
          case "c$":
            return { success: true, value: "c$" };
          case "d'":
            return { success: true, value: "d'" };
          case 'e"':
            return { success: true, value: 'e"' };
          default:
            return { success: false, reason: `[#/components/schemas/NamingEdgecases/a.b]: '${value}' expected to be enum, one of ', a.c, b., c$, d\', e"'.` };
        }
      })(value["a.b"]);
    })();
    if (!parsed_a_b.success) {
      return { success: false, reason: parsed_a_b.reason };
    }
    const parsed_b_ = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "b$")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NamingEdgecases/b$]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["b$"]);
    })();
    if (!parsed_b_.success) {
      return { success: false, reason: parsed_b_.reason };
    }
    const parsed_c_ = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "c?")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NamingEdgecases/c?]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["c?"]);
    })();
    if (!parsed_c_.success) {
      return { success: false, reason: parsed_c_.reason };
    }
    return { success: true, value: { "a.": parsed_a_.value, "a.b": parsed_a_b.value, b$: parsed_b_.value, "c?": parsed_c_.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// NestedBytesData
export function serialize_NestedBytesData(obj: NestedBytesData): string {
  const serialized = ((value: { inner: BytesData }): unknown => {
    return {
      inner: ((value: { data: ReadonlyUint8Array }): unknown => {
        return {
          data: ((value: ReadonlyUint8Array): unknown => {
            return toBase64(value);
          })(value["data"]),
        };
      })(value["inner"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_NestedBytesData(str: string): ParserResult<NestedBytesData> {
  return ((
    value: unknown,
  ): ParserResult<{
    inner: BytesData;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/NestedBytesData]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/NestedBytesData]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "inner")) {
      return { success: false, reason: `[#/components/schemas/NestedBytesData/inner]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'inner'.` };
    }
    const parsed_inner = ((): ParserResult<BytesData> => {
      return ((value: unknown): ParserResult<BytesData> => {
        return ((
          value: unknown,
        ): ParserResult<{
          data: ReadonlyUint8Array;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/BytesData]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/BytesData]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "data")) {
            return { success: false, reason: `[#/components/schemas/BytesData/data]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'data'.` };
          }
          const parsed_data = ((): ParserResult<ReadonlyUint8Array> => {
            return ((value: unknown): ParserResult<ReadonlyUint8Array> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/BytesData/data]: '${value}' expected to be of type string.` };
              }
              const binary = (() => {
                try {
                  const binaryString = atob(value);
                  const arr = new Uint8Array(binaryString.length);
                  for (let i = 0; i < binaryString.length; i++) {
                    arr[i] = binaryString.charCodeAt(i);
                  }
                  return arr;
                } catch (ex) {
                  return null;
                }
              })();
              if (binary === null) {
                return { success: false, reason: `[#/components/schemas/BytesData/data]: '${value}' expected to be a valid base64 string.` };
              }
              return { success: true, value: binary };
            })(value["data"]);
          })();
          if (!parsed_data.success) {
            return { success: false, reason: parsed_data.reason };
          }
          return { success: true, value: { data: parsed_data.value } };
        })(value);
      })(value["inner"]);
    })();
    if (!parsed_inner.success) {
      return { success: false, reason: parsed_inner.reason };
    }
    return { success: true, value: { inner: parsed_inner.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// NonRequiredNullable
export function serialize_NonRequiredNullable(obj: NonRequiredNullable): string {
  const serialized = ((value: { data?: number | null }): unknown => {
    return {
      data: ((value: number | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value;
      })(value["data"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_NonRequiredNullable(str: string): ParserResult<NonRequiredNullable> {
  return ((
    value: unknown,
  ): ParserResult<{
    data?: number | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/NonRequiredNullable]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/NonRequiredNullable]: '${value}' expected to not be null.` };
    }
    const parsed_data = ((): ParserResult<number | null | undefined> => {
      if (!hasProp(value, "data")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<number | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/NonRequiredNullable/data]: '${value}' expected to be of type number.` };
      })(value["data"]);
    })();
    if (!parsed_data.success) {
      return { success: false, reason: parsed_data.reason };
    }
    return { success: true, value: { data: parsed_data.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// NullableObjectInObject
export function serialize_NullableObjectInObject(obj: NullableObjectInObject): string {
  const serialized = ((value: {
    inner1: {
      inner2: string;
    } | null;
  }): unknown => {
    return {
      inner1: ((
        value: {
          inner2: string;
        } | null,
      ): unknown => {
        if (value === null) {
          return null;
        }
        return {
          inner2: ((value: string): unknown => {
            return value;
          })(value["inner2"]),
        };
      })(value["inner1"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_NullableObjectInObject(str: string): ParserResult<NullableObjectInObject> {
  return ((
    value: unknown,
  ): ParserResult<{
    inner1: {
      inner2: string;
    } | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/NullableObjectInObject]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/NullableObjectInObject]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "inner1")) {
      return { success: false, reason: `[#/components/schemas/NullableObjectInObject/inner1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'inner1'.` };
    }
    const parsed_inner1 = ((): ParserResult<{
      inner2: string;
    } | null> => {
      return ((
        value: unknown,
      ): ParserResult<{
        inner2: string;
      } | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/NullableObjectInObject/inner1]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/NullableObjectInObject/inner1]: '${value}' expected to not be null.` };
        }
        if (!hasProp(value, "inner2")) {
          return { success: false, reason: `[#/components/schemas/NullableObjectInObject/inner1/inner2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'inner2'.` };
        }
        const parsed_inner2 = ((): ParserResult<string> => {
          return ((value: unknown): ParserResult<string> => {
            if (typeof value !== "string") {
              return { success: false, reason: `[#/components/schemas/NullableObjectInObject/inner1/inner2]: '${value}' expected to be of type string.` };
            }
            return { success: true, value: value };
          })(value["inner2"]);
        })();
        if (!parsed_inner2.success) {
          return { success: false, reason: parsed_inner2.reason };
        }
        return { success: true, value: { inner2: parsed_inner2.value } };
      })(value["inner1"]);
    })();
    if (!parsed_inner1.success) {
      return { success: false, reason: parsed_inner1.reason };
    }
    return { success: true, value: { inner1: parsed_inner1.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// ObjInArrInArr
export function serialize_ObjInArrInArr(obj: ObjInArrInArr): string {
  const serialized = ((value: {
    arr1: {
      arr2: {
        obj1: {
          arr3: any[];
        };
      }[];
    }[];
  }): unknown => {
    return {
      arr1: ((
        value: {
          arr2: {
            obj1: {
              arr3: any[];
            };
          }[];
        }[],
      ): unknown => {
        return value.map(
          (value: {
            arr2: {
              obj1: {
                arr3: any[];
              };
            }[];
          }): unknown => {
            return {
              arr2: ((
                value: {
                  obj1: {
                    arr3: any[];
                  };
                }[],
              ): unknown => {
                return value.map(
                  (value: {
                    obj1: {
                      arr3: any[];
                    };
                  }): unknown => {
                    return {
                      obj1: ((value: { arr3: any[] }): unknown => {
                        return {
                          arr3: ((value: any[]): unknown => {
                            return value.map((value: any): unknown => {
                              return value;
                            });
                          })(value["arr3"]),
                        };
                      })(value["obj1"]),
                    };
                  },
                );
              })(value["arr2"]),
            };
          },
        );
      })(value["arr1"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ObjInArrInArr(str: string): ParserResult<ObjInArrInArr> {
  return ((
    value: unknown,
  ): ParserResult<{
    arr1: {
      arr2: {
        obj1: {
          arr3: any[];
        };
      }[];
    }[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ObjInArrInArr]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ObjInArrInArr]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "arr1")) {
      return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr1'.` };
    }
    const parsed_arr1 = ((): ParserResult<
      {
        arr2: {
          obj1: {
            arr3: any[];
          };
        }[];
      }[]
    > => {
      return ((
        value: unknown,
      ): ParserResult<
        {
          arr2: {
            obj1: {
              arr3: any[];
            };
          }[];
        }[]
      > => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1]: '${value}' expected to be an array.` };
        }
        const parsed = value.map(
          (
            value: unknown,
          ): ParserResult<{
            arr2: {
              obj1: {
                arr3: any[];
              };
            }[];
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "arr2")) {
              return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr2'.` };
            }
            const parsed_arr2 = ((): ParserResult<
              {
                obj1: {
                  arr3: any[];
                };
              }[]
            > => {
              return ((
                value: unknown,
              ): ParserResult<
                {
                  obj1: {
                    arr3: any[];
                  };
                }[]
              > => {
                if (!isArray(value)) {
                  return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2]: '${value}' expected to be an array.` };
                }
                const parsed = value.map(
                  (
                    value: unknown,
                  ): ParserResult<{
                    obj1: {
                      arr3: any[];
                    };
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2/[object]]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2/[object]]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "obj1")) {
                      return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2/[object]/obj1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'obj1'.` };
                    }
                    const parsed_obj1 = ((): ParserResult<{
                      arr3: any[];
                    }> => {
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        arr3: any[];
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2/[object]/obj1]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2/[object]/obj1]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "arr3")) {
                          return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2/[object]/obj1/arr3]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr3'.` };
                        }
                        const parsed_arr3 = ((): ParserResult<any[]> => {
                          return ((value: unknown): ParserResult<any[]> => {
                            if (!isArray(value)) {
                              return { success: false, reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2/[object]/obj1/arr3]: '${value}' expected to be an array.` };
                            }
                            const parsed = value.map((value: unknown): ParserResult<any> => {
                              return { success: true, value: value };
                            });
                            if (parsed.find((value) => !value.success) !== undefined) {
                              return {
                                success: false,
                                reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2/[object]/obj1/arr3]: Reason(s): '${parsed
                                  .filter((p) => !p.success)
                                  .map((p) => p.reason)
                                  .join(", ")}'.`,
                              };
                            }
                            return {
                              success: true,
                              value: parsed.map((entry) => {
                                assert(entry.success == true);
                                return entry.value;
                              }),
                            };
                          })(value["arr3"]);
                        })();
                        if (!parsed_arr3.success) {
                          return { success: false, reason: parsed_arr3.reason };
                        }
                        return { success: true, value: { arr3: parsed_arr3.value } };
                      })(value["obj1"]);
                    })();
                    if (!parsed_obj1.success) {
                      return { success: false, reason: parsed_obj1.reason };
                    }
                    return { success: true, value: { obj1: parsed_obj1.value } };
                  },
                );
                if (parsed.find((value) => !value.success) !== undefined) {
                  return {
                    success: false,
                    reason: `[#/components/schemas/ObjInArrInArr/arr1/[object]/arr2]: Reason(s): '${parsed
                      .filter((p) => !p.success)
                      .map((p) => p.reason)
                      .join(", ")}'.`,
                  };
                }
                return {
                  success: true,
                  value: parsed.map((entry) => {
                    assert(entry.success == true);
                    return entry.value;
                  }),
                };
              })(value["arr2"]);
            })();
            if (!parsed_arr2.success) {
              return { success: false, reason: parsed_arr2.reason };
            }
            return { success: true, value: { arr2: parsed_arr2.value } };
          },
        );
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ObjInArrInArr/arr1]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr1"]);
    })();
    if (!parsed_arr1.success) {
      return { success: false, reason: parsed_arr1.reason };
    }
    return { success: true, value: { arr1: parsed_arr1.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// ObjInObjInObj
export function serialize_ObjInObjInObj(obj: ObjInObjInObj): string {
  const serialized = ((value: {
    obj1: {
      obj2: {
        obj3: {
          str: string;
        };
      };
    };
  }): unknown => {
    return {
      obj1: ((value: {
        obj2: {
          obj3: {
            str: string;
          };
        };
      }): unknown => {
        return {
          obj2: ((value: {
            obj3: {
              str: string;
            };
          }): unknown => {
            return {
              obj3: ((value: { str: string }): unknown => {
                return {
                  str: ((value: string): unknown => {
                    return value;
                  })(value["str"]),
                };
              })(value["obj3"]),
            };
          })(value["obj2"]),
        };
      })(value["obj1"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ObjInObjInObj(str: string): ParserResult<ObjInObjInObj> {
  return ((
    value: unknown,
  ): ParserResult<{
    obj1: {
      obj2: {
        obj3: {
          str: string;
        };
      };
    };
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ObjInObjInObj]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ObjInObjInObj]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "obj1")) {
      return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'obj1'.` };
    }
    const parsed_obj1 = ((): ParserResult<{
      obj2: {
        obj3: {
          str: string;
        };
      };
    }> => {
      return ((
        value: unknown,
      ): ParserResult<{
        obj2: {
          obj3: {
            str: string;
          };
        };
      }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1]: '${value}' expected to not be null.` };
        }
        if (!hasProp(value, "obj2")) {
          return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1/obj2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'obj2'.` };
        }
        const parsed_obj2 = ((): ParserResult<{
          obj3: {
            str: string;
          };
        }> => {
          return ((
            value: unknown,
          ): ParserResult<{
            obj3: {
              str: string;
            };
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1/obj2]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1/obj2]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "obj3")) {
              return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1/obj2/obj3]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'obj3'.` };
            }
            const parsed_obj3 = ((): ParserResult<{
              str: string;
            }> => {
              return ((
                value: unknown,
              ): ParserResult<{
                str: string;
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1/obj2/obj3]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1/obj2/obj3]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "str")) {
                  return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1/obj2/obj3/str]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'str'.` };
                }
                const parsed_str = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/ObjInObjInObj/obj1/obj2/obj3/str]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["str"]);
                })();
                if (!parsed_str.success) {
                  return { success: false, reason: parsed_str.reason };
                }
                return { success: true, value: { str: parsed_str.value } };
              })(value["obj3"]);
            })();
            if (!parsed_obj3.success) {
              return { success: false, reason: parsed_obj3.reason };
            }
            return { success: true, value: { obj3: parsed_obj3.value } };
          })(value["obj2"]);
        })();
        if (!parsed_obj2.success) {
          return { success: false, reason: parsed_obj2.reason };
        }
        return { success: true, value: { obj2: parsed_obj2.value } };
      })(value["obj1"]);
    })();
    if (!parsed_obj1.success) {
      return { success: false, reason: parsed_obj1.reason };
    }
    return { success: true, value: { obj1: parsed_obj1.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// ObjectArrayContainer
export function serialize_ObjectArrayContainer(obj: ObjectArrayContainer): string {
  const serialized = ((value: {
    arr1: {
      intValue: number;
    }[];
    arr2:
      | {
          intValue: number;
        }[]
      | null;
    arr3?: {
      intValue: number;
    }[];
    arr4?:
      | {
          intValue: number;
        }[]
      | null;
  }): unknown => {
    return {
      arr1: ((
        value: {
          intValue: number;
        }[],
      ): unknown => {
        return value.map((value: { intValue: number }): unknown => {
          return {
            intValue: ((value: number): unknown => {
              return value;
            })(value["intValue"]),
          };
        });
      })(value["arr1"]),
      arr2: ((
        value:
          | {
              intValue: number;
            }[]
          | null,
      ): unknown => {
        if (value === null) {
          return null;
        }
        return value.map((value: { intValue: number }): unknown => {
          return {
            intValue: ((value: number): unknown => {
              return value;
            })(value["intValue"]),
          };
        });
      })(value["arr2"]),
      arr3: ((
        value:
          | {
              intValue: number;
            }[]
          | undefined,
      ): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value.map((value: { intValue: number }): unknown => {
          return {
            intValue: ((value: number): unknown => {
              return value;
            })(value["intValue"]),
          };
        });
      })(value["arr3"]),
      arr4: ((
        value:
          | {
              intValue: number;
            }[]
          | null
          | undefined,
      ): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value.map((value: { intValue: number }): unknown => {
          return {
            intValue: ((value: number): unknown => {
              return value;
            })(value["intValue"]),
          };
        });
      })(value["arr4"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ObjectArrayContainer(str: string): ParserResult<ObjectArrayContainer> {
  return ((
    value: unknown,
  ): ParserResult<{
    arr1: {
      intValue: number;
    }[];
    arr2:
      | {
          intValue: number;
        }[]
      | null;
    arr3?: {
      intValue: number;
    }[];
    arr4?:
      | {
          intValue: number;
        }[]
      | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ObjectArrayContainer]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ObjectArrayContainer]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "arr1")) {
      return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr1'.` };
    }
    const parsed_arr1 = ((): ParserResult<
      {
        intValue: number;
      }[]
    > => {
      return ((
        value: unknown,
      ): ParserResult<
        {
          intValue: number;
        }[]
      > => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr1]: '${value}' expected to be an array.` };
        }
        const parsed = value.map(
          (
            value: unknown,
          ): ParserResult<{
            intValue: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr1/[object]]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr1/[object]]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "intValue")) {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr1/[object]/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
            }
            const parsed_intValue = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr1/[object]/intValue]: '${value}' expected to be of type number.` };
              })(value["intValue"]);
            })();
            if (!parsed_intValue.success) {
              return { success: false, reason: parsed_intValue.reason };
            }
            return { success: true, value: { intValue: parsed_intValue.value } };
          },
        );
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ObjectArrayContainer/arr1]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr1"]);
    })();
    if (!parsed_arr1.success) {
      return { success: false, reason: parsed_arr1.reason };
    }
    if (!hasProp(value, "arr2")) {
      return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr2'.` };
    }
    const parsed_arr2 = ((): ParserResult<
      | {
          intValue: number;
        }[]
      | null
    > => {
      return ((
        value: unknown,
      ): ParserResult<
        | {
            intValue: number;
          }[]
        | null
      > => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr2]: '${value}' expected to be an array.` };
        }
        const parsed = value.map(
          (
            value: unknown,
          ): ParserResult<{
            intValue: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr2/[object]]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr2/[object]]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "intValue")) {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr2/[object]/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
            }
            const parsed_intValue = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr2/[object]/intValue]: '${value}' expected to be of type number.` };
              })(value["intValue"]);
            })();
            if (!parsed_intValue.success) {
              return { success: false, reason: parsed_intValue.reason };
            }
            return { success: true, value: { intValue: parsed_intValue.value } };
          },
        );
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ObjectArrayContainer/arr2]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr2"]);
    })();
    if (!parsed_arr2.success) {
      return { success: false, reason: parsed_arr2.reason };
    }
    const parsed_arr3 = ((): ParserResult<
      | {
          intValue: number;
        }[]
      | undefined
    > => {
      if (!hasProp(value, "arr3")) {
        return { success: true, value: undefined };
      }
      return ((
        value: unknown,
      ): ParserResult<
        | {
            intValue: number;
          }[]
        | undefined
      > => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr3]: '${value}' expected to be an array.` };
        }
        const parsed = value.map(
          (
            value: unknown,
          ): ParserResult<{
            intValue: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr3/[object]]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr3/[object]]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "intValue")) {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr3/[object]/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
            }
            const parsed_intValue = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr3/[object]/intValue]: '${value}' expected to be of type number.` };
              })(value["intValue"]);
            })();
            if (!parsed_intValue.success) {
              return { success: false, reason: parsed_intValue.reason };
            }
            return { success: true, value: { intValue: parsed_intValue.value } };
          },
        );
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ObjectArrayContainer/arr3]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr3"]);
    })();
    if (!parsed_arr3.success) {
      return { success: false, reason: parsed_arr3.reason };
    }
    const parsed_arr4 = ((): ParserResult<
      | {
          intValue: number;
        }[]
      | null
      | undefined
    > => {
      if (!hasProp(value, "arr4")) {
        return { success: true, value: undefined };
      }
      return ((
        value: unknown,
      ): ParserResult<
        | {
            intValue: number;
          }[]
        | null
        | undefined
      > => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr4]: '${value}' expected to be an array.` };
        }
        const parsed = value.map(
          (
            value: unknown,
          ): ParserResult<{
            intValue: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr4/[object]]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr4/[object]]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "intValue")) {
              return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr4/[object]/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
            }
            const parsed_intValue = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ObjectArrayContainer/arr4/[object]/intValue]: '${value}' expected to be of type number.` };
              })(value["intValue"]);
            })();
            if (!parsed_intValue.success) {
              return { success: false, reason: parsed_intValue.reason };
            }
            return { success: true, value: { intValue: parsed_intValue.value } };
          },
        );
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ObjectArrayContainer/arr4]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr4"]);
    })();
    if (!parsed_arr4.success) {
      return { success: false, reason: parsed_arr4.reason };
    }
    return { success: true, value: { arr1: parsed_arr1.value, arr2: parsed_arr2.value, arr3: parsed_arr3.value, arr4: parsed_arr4.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfEarlyName
export function serialize_OneOfEarlyName(obj: OneOfEarlyName): string {
  const serialized = ((value: { a_kind: "num"; elem: string }): unknown => {
    switch (value.a_kind) {
      case "num": {
        return {
          a_kind: "num",
          elem: ((value: string): unknown => {
            return value;
          })(value["elem"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfEarlyName(str: string): ParserResult<OneOfEarlyName> {
  return ((value: unknown): ParserResult<{ a_kind: "num"; elem: string }> => {
    return ((value: unknown): ParserResult<{ a_kind: "num"; elem: string }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/OneOfEarlyName]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/OneOfEarlyName]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "a_kind")) {
        return { success: false, reason: `[#/components/schemas/OneOfEarlyName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'a_kind'.` };
      }
      if (typeof value["a_kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/OneOfEarlyName]: '${value["a_kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["a_kind"];
      switch (discriminator) {
        case "num": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            elem: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfEarlyName/num]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfEarlyName/num]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "elem")) {
              return { success: false, reason: `[#/components/schemas/OneOfEarlyName/num/elem]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'elem'.` };
            }
            const parsed_elem = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfEarlyName/num/elem]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["elem"]);
            })();
            if (!parsed_elem.success) {
              return { success: false, reason: parsed_elem.reason };
            }
            return { success: true, value: { elem: parsed_elem.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { a_kind: "num" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/OneOfEarlyName]: '${discriminator}' expected to be one of 'num'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfExplicitDiscriminatorExample
export function serialize_OneOfExplicitDiscriminatorExample(obj: OneOfExplicitDiscriminatorExample): string {
  const serialized = ((value: { kind: "num"; num?: number } | { kind: "string"; str?: string }): unknown => {
    switch (value.kind) {
      case "num": {
        return {
          kind: "num",
          num: ((value: number | undefined): unknown => {
            if (value === undefined) {
              return undefined;
            }
            return value;
          })(value["num"]),
        };
      }
      case "string": {
        return {
          kind: "string",
          str: ((value: string | undefined): unknown => {
            if (value === undefined) {
              return undefined;
            }
            return value;
          })(value["str"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfExplicitDiscriminatorExample(str: string): ParserResult<OneOfExplicitDiscriminatorExample> {
  return ((value: unknown): ParserResult<{ kind: "num"; num?: number } | { kind: "string"; str?: string }> => {
    return ((value: unknown): ParserResult<{ kind: "num"; num?: number } | { kind: "string"; str?: string }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "num": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            num?: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample/num]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample/num]: '${value}' expected to not be null.` };
            }
            const parsed_num = ((): ParserResult<number | undefined> => {
              if (!hasProp(value, "num")) {
                return { success: true, value: undefined };
              }
              return ((value: unknown): ParserResult<number | undefined> => {
                if (value === undefined) {
                  return { success: true, value: undefined };
                }
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample/num/num]: '${value}' expected to be of type number.` };
              })(value["num"]);
            })();
            if (!parsed_num.success) {
              return { success: false, reason: parsed_num.reason };
            }
            return { success: true, value: { num: parsed_num.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "num" as const, ...parsedVariant.value } };
        }
        case "string": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            str?: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample/string]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample/string]: '${value}' expected to not be null.` };
            }
            const parsed_str = ((): ParserResult<string | undefined> => {
              if (!hasProp(value, "str")) {
                return { success: true, value: undefined };
              }
              return ((value: unknown): ParserResult<string | undefined> => {
                if (value === undefined) {
                  return { success: true, value: undefined };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample/string/str]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["str"]);
            })();
            if (!parsed_str.success) {
              return { success: false, reason: parsed_str.reason };
            }
            return { success: true, value: { str: parsed_str.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "string" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorExample]: '${discriminator}' expected to be one of 'num, string'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfExplicitDiscriminatorMultiNestingExample
export function serialize_OneOfExplicitDiscriminatorMultiNestingExample(obj: OneOfExplicitDiscriminatorMultiNestingExample): string {
  const serialized = ((
    value:
      | {
          kind: "obj";
          obj_data: {
            inner: { kind: "a"; a_data: number } | { kind: "b"; b_data: string };
          };
        }
      | { kind: "string"; str_data: string },
  ): unknown => {
    switch (value.kind) {
      case "obj": {
        return {
          kind: "obj",
          obj_data: ((value: { inner: { kind: "a"; a_data: number } | { kind: "b"; b_data: string } }): unknown => {
            return {
              inner: ((value: { kind: "a"; a_data: number } | { kind: "b"; b_data: string }): unknown => {
                switch (value.kind) {
                  case "a": {
                    return {
                      kind: "a",
                      a_data: ((value: number): unknown => {
                        return value;
                      })(value["a_data"]),
                    };
                  }
                  case "b": {
                    return {
                      kind: "b",
                      b_data: ((value: string): unknown => {
                        return value;
                      })(value["b_data"]),
                    };
                  }
                }
              })(value["inner"]),
            };
          })(value["obj_data"]),
        };
      }
      case "string": {
        return {
          kind: "string",
          str_data: ((value: string): unknown => {
            return value;
          })(value["str_data"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfExplicitDiscriminatorMultiNestingExample(str: string): ParserResult<OneOfExplicitDiscriminatorMultiNestingExample> {
  return ((
    value: unknown,
  ): ParserResult<
    | {
        kind: "obj";
        obj_data: {
          inner: { kind: "a"; a_data: number } | { kind: "b"; b_data: string };
        };
      }
    | { kind: "string"; str_data: string }
  > => {
    return ((
      value: unknown,
    ): ParserResult<
      | {
          kind: "obj";
          obj_data: {
            inner: { kind: "a"; a_data: number } | { kind: "b"; b_data: string };
          };
        }
      | { kind: "string"; str_data: string }
    > => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "obj": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            obj_data: {
              inner: { kind: "a"; a_data: number } | { kind: "b"; b_data: string };
            };
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "obj_data")) {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'obj_data'.` };
            }
            const parsed_obj_data = ((): ParserResult<{
              inner: { kind: "a"; a_data: number } | { kind: "b"; b_data: string };
            }> => {
              return ((
                value: unknown,
              ): ParserResult<{
                inner: { kind: "a"; a_data: number } | { kind: "b"; b_data: string };
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "inner")) {
                  return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'inner'.` };
                }
                const parsed_inner = ((): ParserResult<{ kind: "a"; a_data: number } | { kind: "b"; b_data: string }> => {
                  return ((value: unknown): ParserResult<{ kind: "a"; a_data: number } | { kind: "b"; b_data: string }> => {
                    return ((value: unknown): ParserResult<{ kind: "a"; a_data: number } | { kind: "b"; b_data: string }> => {
                      if (value == null) {
                        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner]: '${value}' expected to be non-null.` };
                      }
                      if (typeof value != "object") {
                        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner]: ${value} expected to be of type 'object'.` };
                      }
                      if (!hasProp(value, "kind")) {
                        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                      }
                      if (typeof value["kind"] != "string") {
                        return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner]: '${value["kind"]}' expected to be of type 'string'.` };
                      }
                      const discriminator = value["kind"];
                      switch (discriminator) {
                        case "a": {
                          const parsedVariant = ((
                            value: unknown,
                          ): ParserResult<{
                            a_data: number;
                          }> => {
                            if (typeof value !== "object") {
                              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner/a]: '${value}' expected to be of type 'object'.` };
                            }
                            if (value === null) {
                              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner/a]: '${value}' expected to not be null.` };
                            }
                            if (!hasProp(value, "a_data")) {
                              return {
                                success: false,
                                reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner/a/a_data]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'a_data'.`,
                              };
                            }
                            const parsed_a_data = ((): ParserResult<number> => {
                              return ((value: unknown): ParserResult<number> => {
                                if (typeof value === "number") {
                                  return { success: true, value: value };
                                }
                                return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner/a/a_data]: '${value}' expected to be of type number.` };
                              })(value["a_data"]);
                            })();
                            if (!parsed_a_data.success) {
                              return { success: false, reason: parsed_a_data.reason };
                            }
                            return { success: true, value: { a_data: parsed_a_data.value } };
                          })(value);
                          if (!parsedVariant.success) {
                            return { success: false, reason: parsedVariant.reason };
                          }
                          return { success: true, value: { kind: "a" as const, ...parsedVariant.value } };
                        }
                        case "b": {
                          const parsedVariant = ((
                            value: unknown,
                          ): ParserResult<{
                            b_data: string;
                          }> => {
                            if (typeof value !== "object") {
                              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner/b]: '${value}' expected to be of type 'object'.` };
                            }
                            if (value === null) {
                              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner/b]: '${value}' expected to not be null.` };
                            }
                            if (!hasProp(value, "b_data")) {
                              return {
                                success: false,
                                reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner/b/b_data]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'b_data'.`,
                              };
                            }
                            const parsed_b_data = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner/b/b_data]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["b_data"]);
                            })();
                            if (!parsed_b_data.success) {
                              return { success: false, reason: parsed_b_data.reason };
                            }
                            return { success: true, value: { b_data: parsed_b_data.value } };
                          })(value);
                          if (!parsedVariant.success) {
                            return { success: false, reason: parsedVariant.reason };
                          }
                          return { success: true, value: { kind: "b" as const, ...parsedVariant.value } };
                        }
                        default:
                          return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/obj/obj_data/inner]: '${discriminator}' expected to be one of 'a, b'.` };
                      }
                    })(value);
                  })(value["inner"]);
                })();
                if (!parsed_inner.success) {
                  return { success: false, reason: parsed_inner.reason };
                }
                return { success: true, value: { inner: parsed_inner.value } };
              })(value["obj_data"]);
            })();
            if (!parsed_obj_data.success) {
              return { success: false, reason: parsed_obj_data.reason };
            }
            return { success: true, value: { obj_data: parsed_obj_data.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "obj" as const, ...parsedVariant.value } };
        }
        case "string": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            str_data: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/string]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/string]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "str_data")) {
              return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/string/str_data]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'str_data'.` };
            }
            const parsed_str_data = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample/string/str_data]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["str_data"]);
            })();
            if (!parsed_str_data.success) {
              return { success: false, reason: parsed_str_data.reason };
            }
            return { success: true, value: { str_data: parsed_str_data.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "string" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/OneOfExplicitDiscriminatorMultiNestingExample]: '${discriminator}' expected to be one of 'obj, string'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfInsideArrayExample
export function serialize_OneOfInsideArrayExample(obj: OneOfInsideArrayExample): string {
  const serialized = ((value: { arr: ({ kind: "one"; one_data: number } | { kind: "two"; two_data: string })[] }): unknown => {
    return {
      arr: ((value: ({ kind: "one"; one_data: number } | { kind: "two"; two_data: string })[]): unknown => {
        return value.map((value: { kind: "one"; one_data: number } | { kind: "two"; two_data: string }): unknown => {
          switch (value.kind) {
            case "one": {
              return {
                kind: "one",
                one_data: ((value: number): unknown => {
                  return value;
                })(value["one_data"]),
              };
            }
            case "two": {
              return {
                kind: "two",
                two_data: ((value: string): unknown => {
                  return value;
                })(value["two_data"]),
              };
            }
          }
        });
      })(value["arr"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfInsideArrayExample(str: string): ParserResult<OneOfInsideArrayExample> {
  return ((
    value: unknown,
  ): ParserResult<{
    arr: ({ kind: "one"; one_data: number } | { kind: "two"; two_data: string })[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "arr")) {
      return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr'.` };
    }
    const parsed_arr = ((): ParserResult<({ kind: "one"; one_data: number } | { kind: "two"; two_data: string })[]> => {
      return ((value: unknown): ParserResult<({ kind: "one"; one_data: number } | { kind: "two"; two_data: string })[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<{ kind: "one"; one_data: number } | { kind: "two"; two_data: string }> => {
          return ((value: unknown): ParserResult<{ kind: "one"; one_data: number } | { kind: "two"; two_data: string }> => {
            if (value == null) {
              return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]]: '${value}' expected to be non-null.` };
            }
            if (typeof value != "object") {
              return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]]: ${value} expected to be of type 'object'.` };
            }
            if (!hasProp(value, "kind")) {
              return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
            }
            if (typeof value["kind"] != "string") {
              return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]]: '${value["kind"]}' expected to be of type 'string'.` };
            }
            const discriminator = value["kind"];
            switch (discriminator) {
              case "one": {
                const parsedVariant = ((
                  value: unknown,
                ): ParserResult<{
                  one_data: number;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]/one]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]/one]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "one_data")) {
                    return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]/one/one_data]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'one_data'.` };
                  }
                  const parsed_one_data = ((): ParserResult<number> => {
                    return ((value: unknown): ParserResult<number> => {
                      if (typeof value === "number") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]/one/one_data]: '${value}' expected to be of type number.` };
                    })(value["one_data"]);
                  })();
                  if (!parsed_one_data.success) {
                    return { success: false, reason: parsed_one_data.reason };
                  }
                  return { success: true, value: { one_data: parsed_one_data.value } };
                })(value);
                if (!parsedVariant.success) {
                  return { success: false, reason: parsedVariant.reason };
                }
                return { success: true, value: { kind: "one" as const, ...parsedVariant.value } };
              }
              case "two": {
                const parsedVariant = ((
                  value: unknown,
                ): ParserResult<{
                  two_data: string;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]/two]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]/two]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "two_data")) {
                    return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]/two/two_data]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'two_data'.` };
                  }
                  const parsed_two_data = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]/two/two_data]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["two_data"]);
                  })();
                  if (!parsed_two_data.success) {
                    return { success: false, reason: parsed_two_data.reason };
                  }
                  return { success: true, value: { two_data: parsed_two_data.value } };
                })(value);
                if (!parsedVariant.success) {
                  return { success: false, reason: parsedVariant.reason };
                }
                return { success: true, value: { kind: "two" as const, ...parsedVariant.value } };
              }
              default:
                return { success: false, reason: `[#/components/schemas/OneOfInsideArrayExample/arr/[null]]: '${discriminator}' expected to be one of 'one, two'.` };
            }
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/OneOfInsideArrayExample/arr]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr"]);
    })();
    if (!parsed_arr.success) {
      return { success: false, reason: parsed_arr.reason };
    }
    return { success: true, value: { arr: parsed_arr.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfLateName
export function serialize_OneOfLateName(obj: OneOfLateName): string {
  const serialized = ((value: { z_kind: "num"; elem: string }): unknown => {
    switch (value.z_kind) {
      case "num": {
        return {
          z_kind: "num",
          elem: ((value: string): unknown => {
            return value;
          })(value["elem"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfLateName(str: string): ParserResult<OneOfLateName> {
  return ((value: unknown): ParserResult<{ z_kind: "num"; elem: string }> => {
    return ((value: unknown): ParserResult<{ z_kind: "num"; elem: string }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/OneOfLateName]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/OneOfLateName]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "z_kind")) {
        return { success: false, reason: `[#/components/schemas/OneOfLateName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'z_kind'.` };
      }
      if (typeof value["z_kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/OneOfLateName]: '${value["z_kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["z_kind"];
      switch (discriminator) {
        case "num": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            elem: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfLateName/num]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfLateName/num]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "elem")) {
              return { success: false, reason: `[#/components/schemas/OneOfLateName/num/elem]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'elem'.` };
            }
            const parsed_elem = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfLateName/num/elem]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["elem"]);
            })();
            if (!parsed_elem.success) {
              return { success: false, reason: parsed_elem.reason };
            }
            return { success: true, value: { elem: parsed_elem.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { z_kind: "num" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/OneOfLateName]: '${discriminator}' expected to be one of 'num'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfPartsBaseExample_A
export function serialize_OneOfPartsBaseExample_A(obj: OneOfPartsBaseExample_A): string {
  const serialized = ((value: { kind: "A"; maybeString: string; sharedProp: string; subNonNullable: SuperExample_AAA; subNullable: SuperExample_AAA }): unknown => {
    return {
      kind: ((value: "A"): unknown => {
        return value;
      })(value["kind"]),
      maybeString: ((value: string): unknown => {
        return value;
      })(value["maybeString"]),
      sharedProp: ((value: string): unknown => {
        return value;
      })(value["sharedProp"]),
      subNonNullable: ((value: { kind: "AAA"; value: string }): unknown => {
        return {
          kind: ((value: "AAA"): unknown => {
            return value;
          })(value["kind"]),
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      })(value["subNonNullable"]),
      subNullable: ((value: { kind: "AAA"; value: string }): unknown => {
        return {
          kind: ((value: "AAA"): unknown => {
            return value;
          })(value["kind"]),
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      })(value["subNullable"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfPartsBaseExample_A(str: string): ParserResult<OneOfPartsBaseExample_A> {
  return ((
    value: unknown,
  ): ParserResult<{
    kind: "A";
    maybeString: string;
    sharedProp: string;
    subNonNullable: SuperExample_AAA;
    subNullable: SuperExample_AAA;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/OneOfPartAExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/OneOfPartAExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartAExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<"A"> => {
      return ((value: unknown): ParserResult<"A"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OneOfPartAExample/kind]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "A":
            return { success: true, value: "A" };
          default:
            return { success: false, reason: `[#/components/schemas/OneOfPartAExample/kind]: '${value}' expected to be enum, one of 'A'.` };
        }
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    if (!hasProp(value, "maybeString")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartAExample/maybeString]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'maybeString'.` };
    }
    const parsed_maybeString = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OneOfPartAExample/maybeString]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["maybeString"]);
    })();
    if (!parsed_maybeString.success) {
      return { success: false, reason: parsed_maybeString.reason };
    }
    if (!hasProp(value, "sharedProp")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartAExample/sharedProp]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sharedProp'.` };
    }
    const parsed_sharedProp = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OneOfPartAExample/sharedProp]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["sharedProp"]);
    })();
    if (!parsed_sharedProp.success) {
      return { success: false, reason: parsed_sharedProp.reason };
    }
    if (!hasProp(value, "subNonNullable")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartAExample/subNonNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNonNullable'.` };
    }
    const parsed_subNonNullable = ((): ParserResult<SuperExample_AAA> => {
      return ((value: unknown): ParserResult<SuperExample_AAA> => {
        return ((
          value: unknown,
        ): ParserResult<{
          kind: "AAA";
          value: string;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "kind")) {
            return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
          }
          const parsed_kind = ((): ParserResult<"AAA"> => {
            return ((value: unknown): ParserResult<"AAA"> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be of type string.` };
              }
              switch (value) {
                case "AAA":
                  return { success: true, value: "AAA" };
                default:
                  return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be enum, one of 'AAA'.` };
              }
            })(value["kind"]);
          })();
          if (!parsed_kind.success) {
            return { success: false, reason: parsed_kind.reason };
          }
          if (!hasProp(value, "value")) {
            return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
          }
          const parsed_value = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["value"]);
          })();
          if (!parsed_value.success) {
            return { success: false, reason: parsed_value.reason };
          }
          return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
        })(value);
      })(value["subNonNullable"]);
    })();
    if (!parsed_subNonNullable.success) {
      return { success: false, reason: parsed_subNonNullable.reason };
    }
    if (!hasProp(value, "subNullable")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartAExample/subNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNullable'.` };
    }
    const parsed_subNullable = ((): ParserResult<SuperExample_AAA> => {
      return ((value: unknown): ParserResult<SuperExample_AAA> => {
        return ((
          value: unknown,
        ): ParserResult<{
          kind: "AAA";
          value: string;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "kind")) {
            return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
          }
          const parsed_kind = ((): ParserResult<"AAA"> => {
            return ((value: unknown): ParserResult<"AAA"> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be of type string.` };
              }
              switch (value) {
                case "AAA":
                  return { success: true, value: "AAA" };
                default:
                  return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be enum, one of 'AAA'.` };
              }
            })(value["kind"]);
          })();
          if (!parsed_kind.success) {
            return { success: false, reason: parsed_kind.reason };
          }
          if (!hasProp(value, "value")) {
            return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
          }
          const parsed_value = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["value"]);
          })();
          if (!parsed_value.success) {
            return { success: false, reason: parsed_value.reason };
          }
          return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
        })(value);
      })(value["subNullable"]);
    })();
    if (!parsed_subNullable.success) {
      return { success: false, reason: parsed_subNullable.reason };
    }
    return { success: true, value: { kind: parsed_kind.value, maybeString: parsed_maybeString.value, sharedProp: parsed_sharedProp.value, subNonNullable: parsed_subNonNullable.value, subNullable: parsed_subNullable.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfPartsBaseExample_B
export function serialize_OneOfPartsBaseExample_B(obj: OneOfPartsBaseExample_B): string {
  const serialized = ((value: { kind: "B"; sharedProp: string; subNonNullable: SuperExample_BBB; subNullable: SuperExample_BBB }): unknown => {
    return {
      kind: ((value: "B"): unknown => {
        return value;
      })(value["kind"]),
      sharedProp: ((value: string): unknown => {
        return value;
      })(value["sharedProp"]),
      subNonNullable: ((value: { kind: "BBB"; value: boolean }): unknown => {
        return {
          kind: ((value: "BBB"): unknown => {
            return value;
          })(value["kind"]),
          value: ((value: boolean): unknown => {
            return value;
          })(value["value"]),
        };
      })(value["subNonNullable"]),
      subNullable: ((value: { kind: "BBB"; value: boolean }): unknown => {
        return {
          kind: ((value: "BBB"): unknown => {
            return value;
          })(value["kind"]),
          value: ((value: boolean): unknown => {
            return value;
          })(value["value"]),
        };
      })(value["subNullable"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfPartsBaseExample_B(str: string): ParserResult<OneOfPartsBaseExample_B> {
  return ((
    value: unknown,
  ): ParserResult<{
    kind: "B";
    sharedProp: string;
    subNonNullable: SuperExample_BBB;
    subNullable: SuperExample_BBB;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/OneOfPartBExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/OneOfPartBExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartBExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<"B"> => {
      return ((value: unknown): ParserResult<"B"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OneOfPartBExample/kind]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "B":
            return { success: true, value: "B" };
          default:
            return { success: false, reason: `[#/components/schemas/OneOfPartBExample/kind]: '${value}' expected to be enum, one of 'B'.` };
        }
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    if (!hasProp(value, "sharedProp")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartBExample/sharedProp]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sharedProp'.` };
    }
    const parsed_sharedProp = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OneOfPartBExample/sharedProp]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["sharedProp"]);
    })();
    if (!parsed_sharedProp.success) {
      return { success: false, reason: parsed_sharedProp.reason };
    }
    if (!hasProp(value, "subNonNullable")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartBExample/subNonNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNonNullable'.` };
    }
    const parsed_subNonNullable = ((): ParserResult<SuperExample_BBB> => {
      return ((value: unknown): ParserResult<SuperExample_BBB> => {
        return ((
          value: unknown,
        ): ParserResult<{
          kind: "BBB";
          value: boolean;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "kind")) {
            return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
          }
          const parsed_kind = ((): ParserResult<"BBB"> => {
            return ((value: unknown): ParserResult<"BBB"> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be of type string.` };
              }
              switch (value) {
                case "BBB":
                  return { success: true, value: "BBB" };
                default:
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be enum, one of 'BBB'.` };
              }
            })(value["kind"]);
          })();
          if (!parsed_kind.success) {
            return { success: false, reason: parsed_kind.reason };
          }
          if (!hasProp(value, "value")) {
            return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
          }
          const parsed_value = ((): ParserResult<boolean> => {
            return ((value: unknown): ParserResult<boolean> => {
              if (typeof value !== "boolean") {
                return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${value}' expected to be of type boolean.` };
              }
              return { success: true, value: value };
            })(value["value"]);
          })();
          if (!parsed_value.success) {
            return { success: false, reason: parsed_value.reason };
          }
          return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
        })(value);
      })(value["subNonNullable"]);
    })();
    if (!parsed_subNonNullable.success) {
      return { success: false, reason: parsed_subNonNullable.reason };
    }
    if (!hasProp(value, "subNullable")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartBExample/subNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNullable'.` };
    }
    const parsed_subNullable = ((): ParserResult<SuperExample_BBB> => {
      return ((value: unknown): ParserResult<SuperExample_BBB> => {
        return ((
          value: unknown,
        ): ParserResult<{
          kind: "BBB";
          value: boolean;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "kind")) {
            return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
          }
          const parsed_kind = ((): ParserResult<"BBB"> => {
            return ((value: unknown): ParserResult<"BBB"> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be of type string.` };
              }
              switch (value) {
                case "BBB":
                  return { success: true, value: "BBB" };
                default:
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be enum, one of 'BBB'.` };
              }
            })(value["kind"]);
          })();
          if (!parsed_kind.success) {
            return { success: false, reason: parsed_kind.reason };
          }
          if (!hasProp(value, "value")) {
            return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
          }
          const parsed_value = ((): ParserResult<boolean> => {
            return ((value: unknown): ParserResult<boolean> => {
              if (typeof value !== "boolean") {
                return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${value}' expected to be of type boolean.` };
              }
              return { success: true, value: value };
            })(value["value"]);
          })();
          if (!parsed_value.success) {
            return { success: false, reason: parsed_value.reason };
          }
          return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
        })(value);
      })(value["subNullable"]);
    })();
    if (!parsed_subNullable.success) {
      return { success: false, reason: parsed_subNullable.reason };
    }
    return { success: true, value: { kind: parsed_kind.value, sharedProp: parsed_sharedProp.value, subNonNullable: parsed_subNonNullable.value, subNullable: parsed_subNullable.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfPartsBaseExample_C
export function serialize_OneOfPartsBaseExample_C(obj: OneOfPartsBaseExample_C): string {
  const serialized = ((value: { kind: "C"; maybeString: string; sharedProp: string; subNonNullable: SuperExample }): unknown => {
    return {
      kind: ((value: "C"): unknown => {
        return value;
      })(value["kind"]),
      maybeString: ((value: string): unknown => {
        return value;
      })(value["maybeString"]),
      sharedProp: ((value: string): unknown => {
        return value;
      })(value["sharedProp"]),
      subNonNullable: ((value: { kind: "AAA"; value: string } | { kind: "BBB"; value: boolean }): unknown => {
        switch (value.kind) {
          case "AAA": {
            return {
              kind: "AAA",
              value: ((value: string): unknown => {
                return value;
              })(value["value"]),
            };
          }
          case "BBB": {
            return {
              kind: "BBB",
              value: ((value: boolean): unknown => {
                return value;
              })(value["value"]),
            };
          }
        }
      })(value["subNonNullable"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfPartsBaseExample_C(str: string): ParserResult<OneOfPartsBaseExample_C> {
  return ((
    value: unknown,
  ): ParserResult<{
    kind: "C";
    maybeString: string;
    sharedProp: string;
    subNonNullable: SuperExample;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/OneOfPartCExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/OneOfPartCExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartCExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<"C"> => {
      return ((value: unknown): ParserResult<"C"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OneOfPartCExample/kind]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "C":
            return { success: true, value: "C" };
          default:
            return { success: false, reason: `[#/components/schemas/OneOfPartCExample/kind]: '${value}' expected to be enum, one of 'C'.` };
        }
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    if (!hasProp(value, "maybeString")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartCExample/maybeString]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'maybeString'.` };
    }
    const parsed_maybeString = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OneOfPartCExample/maybeString]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["maybeString"]);
    })();
    if (!parsed_maybeString.success) {
      return { success: false, reason: parsed_maybeString.reason };
    }
    if (!hasProp(value, "sharedProp")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartCExample/sharedProp]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sharedProp'.` };
    }
    const parsed_sharedProp = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OneOfPartCExample/sharedProp]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["sharedProp"]);
    })();
    if (!parsed_sharedProp.success) {
      return { success: false, reason: parsed_sharedProp.reason };
    }
    if (!hasProp(value, "subNonNullable")) {
      return { success: false, reason: `[#/components/schemas/OneOfPartCExample/subNonNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNonNullable'.` };
    }
    const parsed_subNonNullable = ((): ParserResult<SuperExample> => {
      return ((value: unknown): ParserResult<SuperExample> => {
        return ((value: unknown): ParserResult<{ kind: "AAA"; value: string } | { kind: "BBB"; value: boolean }> => {
          return ((value: unknown): ParserResult<{ kind: "AAA"; value: string } | { kind: "BBB"; value: boolean }> => {
            if (value == null) {
              return { success: false, reason: `[#/components/schemas/SuperExample]: '${value}' expected to be non-null.` };
            }
            if (typeof value != "object") {
              return { success: false, reason: `[#/components/schemas/SuperExample]: ${value} expected to be of type 'object'.` };
            }
            if (!hasProp(value, "kind")) {
              return { success: false, reason: `[#/components/schemas/SuperExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
            }
            if (typeof value["kind"] != "string") {
              return { success: false, reason: `[#/components/schemas/SuperExample]: '${value["kind"]}' expected to be of type 'string'.` };
            }
            const discriminator = value["kind"];
            switch (discriminator) {
              case "AAA": {
                const parsedVariant = ((
                  value: unknown,
                ): ParserResult<{
                  value: string;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/SuperExample/AAA]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/SuperExample/AAA]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "value")) {
                    return { success: false, reason: `[#/components/schemas/SuperExample/AAA/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                  }
                  const parsed_value = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SuperExample/AAA/value]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["value"]);
                  })();
                  if (!parsed_value.success) {
                    return { success: false, reason: parsed_value.reason };
                  }
                  return { success: true, value: { value: parsed_value.value } };
                })(value);
                if (!parsedVariant.success) {
                  return { success: false, reason: parsedVariant.reason };
                }
                return { success: true, value: { kind: "AAA" as const, ...parsedVariant.value } };
              }
              case "BBB": {
                const parsedVariant = ((
                  value: unknown,
                ): ParserResult<{
                  value: boolean;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/SuperExample/BBB]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/SuperExample/BBB]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "value")) {
                    return { success: false, reason: `[#/components/schemas/SuperExample/BBB/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                  }
                  const parsed_value = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/SuperExample/BBB/value]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["value"]);
                  })();
                  if (!parsed_value.success) {
                    return { success: false, reason: parsed_value.reason };
                  }
                  return { success: true, value: { value: parsed_value.value } };
                })(value);
                if (!parsedVariant.success) {
                  return { success: false, reason: parsedVariant.reason };
                }
                return { success: true, value: { kind: "BBB" as const, ...parsedVariant.value } };
              }
              default:
                return { success: false, reason: `[#/components/schemas/SuperExample]: '${discriminator}' expected to be one of 'AAA, BBB'.` };
            }
          })(value);
        })(value);
      })(value["subNonNullable"]);
    })();
    if (!parsed_subNonNullable.success) {
      return { success: false, reason: parsed_subNonNullable.reason };
    }
    return { success: true, value: { kind: parsed_kind.value, maybeString: parsed_maybeString.value, sharedProp: parsed_sharedProp.value, subNonNullable: parsed_subNonNullable.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfPartsBaseExample
export function serialize_OneOfPartsBaseExample(obj: OneOfPartsBaseExample): string {
  const serialized = ((
    value:
      | { kind: "A"; maybeString: string; sharedProp: string; subNonNullable: SuperExample_AAA; subNullable: SuperExample_AAA }
      | { kind: "B"; sharedProp: string; subNonNullable: SuperExample_BBB; subNullable: SuperExample_BBB }
      | { kind: "C"; maybeString: string; sharedProp: string; subNonNullable: SuperExample },
  ): unknown => {
    switch (value.kind) {
      case "A": {
        return {
          kind: "A",
          maybeString: ((value: string): unknown => {
            return value;
          })(value["maybeString"]),
          sharedProp: ((value: string): unknown => {
            return value;
          })(value["sharedProp"]),
          subNonNullable: ((value: { kind: "AAA"; value: string }): unknown => {
            return {
              kind: ((value: "AAA"): unknown => {
                return value;
              })(value["kind"]),
              value: ((value: string): unknown => {
                return value;
              })(value["value"]),
            };
          })(value["subNonNullable"]),
          subNullable: ((value: { kind: "AAA"; value: string }): unknown => {
            return {
              kind: ((value: "AAA"): unknown => {
                return value;
              })(value["kind"]),
              value: ((value: string): unknown => {
                return value;
              })(value["value"]),
            };
          })(value["subNullable"]),
        };
      }
      case "B": {
        return {
          kind: "B",
          sharedProp: ((value: string): unknown => {
            return value;
          })(value["sharedProp"]),
          subNonNullable: ((value: { kind: "BBB"; value: boolean }): unknown => {
            return {
              kind: ((value: "BBB"): unknown => {
                return value;
              })(value["kind"]),
              value: ((value: boolean): unknown => {
                return value;
              })(value["value"]),
            };
          })(value["subNonNullable"]),
          subNullable: ((value: { kind: "BBB"; value: boolean }): unknown => {
            return {
              kind: ((value: "BBB"): unknown => {
                return value;
              })(value["kind"]),
              value: ((value: boolean): unknown => {
                return value;
              })(value["value"]),
            };
          })(value["subNullable"]),
        };
      }
      case "C": {
        return {
          kind: "C",
          maybeString: ((value: string): unknown => {
            return value;
          })(value["maybeString"]),
          sharedProp: ((value: string): unknown => {
            return value;
          })(value["sharedProp"]),
          subNonNullable: ((value: { kind: "AAA"; value: string } | { kind: "BBB"; value: boolean }): unknown => {
            switch (value.kind) {
              case "AAA": {
                return {
                  kind: "AAA",
                  value: ((value: string): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
              case "BBB": {
                return {
                  kind: "BBB",
                  value: ((value: boolean): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
            }
          })(value["subNonNullable"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfPartsBaseExample(str: string): ParserResult<OneOfPartsBaseExample> {
  return ((
    value: unknown,
  ): ParserResult<
    | { kind: "A"; maybeString: string; sharedProp: string; subNonNullable: SuperExample_AAA; subNullable: SuperExample_AAA }
    | { kind: "B"; sharedProp: string; subNonNullable: SuperExample_BBB; subNullable: SuperExample_BBB }
    | { kind: "C"; maybeString: string; sharedProp: string; subNonNullable: SuperExample }
  > => {
    return ((
      value: unknown,
    ): ParserResult<
      | { kind: "A"; maybeString: string; sharedProp: string; subNonNullable: SuperExample_AAA; subNullable: SuperExample_AAA }
      | { kind: "B"; sharedProp: string; subNonNullable: SuperExample_BBB; subNullable: SuperExample_BBB }
      | { kind: "C"; maybeString: string; sharedProp: string; subNonNullable: SuperExample }
    > => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "A": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            maybeString: string;
            sharedProp: string;
            subNonNullable: SuperExample_AAA;
            subNullable: SuperExample_AAA;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/A]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/A]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "maybeString")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/A/maybeString]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'maybeString'.` };
            }
            const parsed_maybeString = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/A/maybeString]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["maybeString"]);
            })();
            if (!parsed_maybeString.success) {
              return { success: false, reason: parsed_maybeString.reason };
            }
            if (!hasProp(value, "sharedProp")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/A/sharedProp]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sharedProp'.` };
            }
            const parsed_sharedProp = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/A/sharedProp]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["sharedProp"]);
            })();
            if (!parsed_sharedProp.success) {
              return { success: false, reason: parsed_sharedProp.reason };
            }
            if (!hasProp(value, "subNonNullable")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/A/subNonNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNonNullable'.` };
            }
            const parsed_subNonNullable = ((): ParserResult<SuperExample_AAA> => {
              return ((value: unknown): ParserResult<SuperExample_AAA> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  kind: "AAA";
                  value: string;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "kind")) {
                    return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                  }
                  const parsed_kind = ((): ParserResult<"AAA"> => {
                    return ((value: unknown): ParserResult<"AAA"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "AAA":
                          return { success: true, value: "AAA" };
                        default:
                          return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be enum, one of 'AAA'.` };
                      }
                    })(value["kind"]);
                  })();
                  if (!parsed_kind.success) {
                    return { success: false, reason: parsed_kind.reason };
                  }
                  if (!hasProp(value, "value")) {
                    return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                  }
                  const parsed_value = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["value"]);
                  })();
                  if (!parsed_value.success) {
                    return { success: false, reason: parsed_value.reason };
                  }
                  return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
                })(value);
              })(value["subNonNullable"]);
            })();
            if (!parsed_subNonNullable.success) {
              return { success: false, reason: parsed_subNonNullable.reason };
            }
            if (!hasProp(value, "subNullable")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/A/subNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNullable'.` };
            }
            const parsed_subNullable = ((): ParserResult<SuperExample_AAA> => {
              return ((value: unknown): ParserResult<SuperExample_AAA> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  kind: "AAA";
                  value: string;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "kind")) {
                    return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                  }
                  const parsed_kind = ((): ParserResult<"AAA"> => {
                    return ((value: unknown): ParserResult<"AAA"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "AAA":
                          return { success: true, value: "AAA" };
                        default:
                          return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be enum, one of 'AAA'.` };
                      }
                    })(value["kind"]);
                  })();
                  if (!parsed_kind.success) {
                    return { success: false, reason: parsed_kind.reason };
                  }
                  if (!hasProp(value, "value")) {
                    return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                  }
                  const parsed_value = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["value"]);
                  })();
                  if (!parsed_value.success) {
                    return { success: false, reason: parsed_value.reason };
                  }
                  return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
                })(value);
              })(value["subNullable"]);
            })();
            if (!parsed_subNullable.success) {
              return { success: false, reason: parsed_subNullable.reason };
            }
            return { success: true, value: { maybeString: parsed_maybeString.value, sharedProp: parsed_sharedProp.value, subNonNullable: parsed_subNonNullable.value, subNullable: parsed_subNullable.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "A" as const, ...parsedVariant.value } };
        }
        case "B": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            sharedProp: string;
            subNonNullable: SuperExample_BBB;
            subNullable: SuperExample_BBB;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/B]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/B]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "sharedProp")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/B/sharedProp]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sharedProp'.` };
            }
            const parsed_sharedProp = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/B/sharedProp]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["sharedProp"]);
            })();
            if (!parsed_sharedProp.success) {
              return { success: false, reason: parsed_sharedProp.reason };
            }
            if (!hasProp(value, "subNonNullable")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/B/subNonNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNonNullable'.` };
            }
            const parsed_subNonNullable = ((): ParserResult<SuperExample_BBB> => {
              return ((value: unknown): ParserResult<SuperExample_BBB> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  kind: "BBB";
                  value: boolean;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "kind")) {
                    return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                  }
                  const parsed_kind = ((): ParserResult<"BBB"> => {
                    return ((value: unknown): ParserResult<"BBB"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "BBB":
                          return { success: true, value: "BBB" };
                        default:
                          return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be enum, one of 'BBB'.` };
                      }
                    })(value["kind"]);
                  })();
                  if (!parsed_kind.success) {
                    return { success: false, reason: parsed_kind.reason };
                  }
                  if (!hasProp(value, "value")) {
                    return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                  }
                  const parsed_value = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["value"]);
                  })();
                  if (!parsed_value.success) {
                    return { success: false, reason: parsed_value.reason };
                  }
                  return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
                })(value);
              })(value["subNonNullable"]);
            })();
            if (!parsed_subNonNullable.success) {
              return { success: false, reason: parsed_subNonNullable.reason };
            }
            if (!hasProp(value, "subNullable")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/B/subNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNullable'.` };
            }
            const parsed_subNullable = ((): ParserResult<SuperExample_BBB> => {
              return ((value: unknown): ParserResult<SuperExample_BBB> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  kind: "BBB";
                  value: boolean;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "kind")) {
                    return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                  }
                  const parsed_kind = ((): ParserResult<"BBB"> => {
                    return ((value: unknown): ParserResult<"BBB"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "BBB":
                          return { success: true, value: "BBB" };
                        default:
                          return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be enum, one of 'BBB'.` };
                      }
                    })(value["kind"]);
                  })();
                  if (!parsed_kind.success) {
                    return { success: false, reason: parsed_kind.reason };
                  }
                  if (!hasProp(value, "value")) {
                    return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                  }
                  const parsed_value = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["value"]);
                  })();
                  if (!parsed_value.success) {
                    return { success: false, reason: parsed_value.reason };
                  }
                  return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
                })(value);
              })(value["subNullable"]);
            })();
            if (!parsed_subNullable.success) {
              return { success: false, reason: parsed_subNullable.reason };
            }
            return { success: true, value: { sharedProp: parsed_sharedProp.value, subNonNullable: parsed_subNonNullable.value, subNullable: parsed_subNullable.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "B" as const, ...parsedVariant.value } };
        }
        case "C": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            maybeString: string;
            sharedProp: string;
            subNonNullable: SuperExample;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/C]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/C]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "maybeString")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/C/maybeString]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'maybeString'.` };
            }
            const parsed_maybeString = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/C/maybeString]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["maybeString"]);
            })();
            if (!parsed_maybeString.success) {
              return { success: false, reason: parsed_maybeString.reason };
            }
            if (!hasProp(value, "sharedProp")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/C/sharedProp]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sharedProp'.` };
            }
            const parsed_sharedProp = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/C/sharedProp]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["sharedProp"]);
            })();
            if (!parsed_sharedProp.success) {
              return { success: false, reason: parsed_sharedProp.reason };
            }
            if (!hasProp(value, "subNonNullable")) {
              return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample/C/subNonNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNonNullable'.` };
            }
            const parsed_subNonNullable = ((): ParserResult<SuperExample> => {
              return ((value: unknown): ParserResult<SuperExample> => {
                return ((value: unknown): ParserResult<{ kind: "AAA"; value: string } | { kind: "BBB"; value: boolean }> => {
                  return ((value: unknown): ParserResult<{ kind: "AAA"; value: string } | { kind: "BBB"; value: boolean }> => {
                    if (value == null) {
                      return { success: false, reason: `[#/components/schemas/SuperExample]: '${value}' expected to be non-null.` };
                    }
                    if (typeof value != "object") {
                      return { success: false, reason: `[#/components/schemas/SuperExample]: ${value} expected to be of type 'object'.` };
                    }
                    if (!hasProp(value, "kind")) {
                      return { success: false, reason: `[#/components/schemas/SuperExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                    }
                    if (typeof value["kind"] != "string") {
                      return { success: false, reason: `[#/components/schemas/SuperExample]: '${value["kind"]}' expected to be of type 'string'.` };
                    }
                    const discriminator = value["kind"];
                    switch (discriminator) {
                      case "AAA": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          value: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/SuperExample/AAA]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/SuperExample/AAA]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/SuperExample/AAA/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/SuperExample/AAA/value]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { kind: "AAA" as const, ...parsedVariant.value } };
                      }
                      case "BBB": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          value: boolean;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/SuperExample/BBB]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/SuperExample/BBB]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/SuperExample/BBB/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/SuperExample/BBB/value]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { kind: "BBB" as const, ...parsedVariant.value } };
                      }
                      default:
                        return { success: false, reason: `[#/components/schemas/SuperExample]: '${discriminator}' expected to be one of 'AAA, BBB'.` };
                    }
                  })(value);
                })(value);
              })(value["subNonNullable"]);
            })();
            if (!parsed_subNonNullable.success) {
              return { success: false, reason: parsed_subNonNullable.reason };
            }
            return { success: true, value: { maybeString: parsed_maybeString.value, sharedProp: parsed_sharedProp.value, subNonNullable: parsed_subNonNullable.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "C" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/OneOfPartsBaseExample]: '${discriminator}' expected to be one of 'A, B, C'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfUsePartExample
export function serialize_OneOfUsePartExample(obj: OneOfUsePartExample): string {
  const serialized = ((value: { bbb: OneOfPartsBaseExample_B }): unknown => {
    return {
      bbb: ((value: { kind: "B"; sharedProp: string; subNonNullable: SuperExample_BBB; subNullable: SuperExample_BBB }): unknown => {
        return {
          kind: ((value: "B"): unknown => {
            return value;
          })(value["kind"]),
          sharedProp: ((value: string): unknown => {
            return value;
          })(value["sharedProp"]),
          subNonNullable: ((value: { kind: "BBB"; value: boolean }): unknown => {
            return {
              kind: ((value: "BBB"): unknown => {
                return value;
              })(value["kind"]),
              value: ((value: boolean): unknown => {
                return value;
              })(value["value"]),
            };
          })(value["subNonNullable"]),
          subNullable: ((value: { kind: "BBB"; value: boolean }): unknown => {
            return {
              kind: ((value: "BBB"): unknown => {
                return value;
              })(value["kind"]),
              value: ((value: boolean): unknown => {
                return value;
              })(value["value"]),
            };
          })(value["subNullable"]),
        };
      })(value["bbb"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfUsePartExample(str: string): ParserResult<OneOfUsePartExample> {
  return ((
    value: unknown,
  ): ParserResult<{
    bbb: OneOfPartsBaseExample_B;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/OneOfUsePartExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/OneOfUsePartExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "bbb")) {
      return { success: false, reason: `[#/components/schemas/OneOfUsePartExample/bbb]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bbb'.` };
    }
    const parsed_bbb = ((): ParserResult<OneOfPartsBaseExample_B> => {
      return ((value: unknown): ParserResult<OneOfPartsBaseExample_B> => {
        return ((
          value: unknown,
        ): ParserResult<{
          kind: "B";
          sharedProp: string;
          subNonNullable: SuperExample_BBB;
          subNullable: SuperExample_BBB;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/OneOfPartBExample]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/OneOfPartBExample]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "kind")) {
            return { success: false, reason: `[#/components/schemas/OneOfPartBExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
          }
          const parsed_kind = ((): ParserResult<"B"> => {
            return ((value: unknown): ParserResult<"B"> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/OneOfPartBExample/kind]: '${value}' expected to be of type string.` };
              }
              switch (value) {
                case "B":
                  return { success: true, value: "B" };
                default:
                  return { success: false, reason: `[#/components/schemas/OneOfPartBExample/kind]: '${value}' expected to be enum, one of 'B'.` };
              }
            })(value["kind"]);
          })();
          if (!parsed_kind.success) {
            return { success: false, reason: parsed_kind.reason };
          }
          if (!hasProp(value, "sharedProp")) {
            return { success: false, reason: `[#/components/schemas/OneOfPartBExample/sharedProp]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sharedProp'.` };
          }
          const parsed_sharedProp = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/OneOfPartBExample/sharedProp]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["sharedProp"]);
          })();
          if (!parsed_sharedProp.success) {
            return { success: false, reason: parsed_sharedProp.reason };
          }
          if (!hasProp(value, "subNonNullable")) {
            return { success: false, reason: `[#/components/schemas/OneOfPartBExample/subNonNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNonNullable'.` };
          }
          const parsed_subNonNullable = ((): ParserResult<SuperExample_BBB> => {
            return ((value: unknown): ParserResult<SuperExample_BBB> => {
              return ((
                value: unknown,
              ): ParserResult<{
                kind: "BBB";
                value: boolean;
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "kind")) {
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                }
                const parsed_kind = ((): ParserResult<"BBB"> => {
                  return ((value: unknown): ParserResult<"BBB"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "BBB":
                        return { success: true, value: "BBB" };
                      default:
                        return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be enum, one of 'BBB'.` };
                    }
                  })(value["kind"]);
                })();
                if (!parsed_kind.success) {
                  return { success: false, reason: parsed_kind.reason };
                }
                if (!hasProp(value, "value")) {
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                }
                const parsed_value = ((): ParserResult<boolean> => {
                  return ((value: unknown): ParserResult<boolean> => {
                    if (typeof value !== "boolean") {
                      return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${value}' expected to be of type boolean.` };
                    }
                    return { success: true, value: value };
                  })(value["value"]);
                })();
                if (!parsed_value.success) {
                  return { success: false, reason: parsed_value.reason };
                }
                return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
              })(value);
            })(value["subNonNullable"]);
          })();
          if (!parsed_subNonNullable.success) {
            return { success: false, reason: parsed_subNonNullable.reason };
          }
          if (!hasProp(value, "subNullable")) {
            return { success: false, reason: `[#/components/schemas/OneOfPartBExample/subNullable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subNullable'.` };
          }
          const parsed_subNullable = ((): ParserResult<SuperExample_BBB> => {
            return ((value: unknown): ParserResult<SuperExample_BBB> => {
              return ((
                value: unknown,
              ): ParserResult<{
                kind: "BBB";
                value: boolean;
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "kind")) {
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                }
                const parsed_kind = ((): ParserResult<"BBB"> => {
                  return ((value: unknown): ParserResult<"BBB"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "BBB":
                        return { success: true, value: "BBB" };
                      default:
                        return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be enum, one of 'BBB'.` };
                    }
                  })(value["kind"]);
                })();
                if (!parsed_kind.success) {
                  return { success: false, reason: parsed_kind.reason };
                }
                if (!hasProp(value, "value")) {
                  return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                }
                const parsed_value = ((): ParserResult<boolean> => {
                  return ((value: unknown): ParserResult<boolean> => {
                    if (typeof value !== "boolean") {
                      return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${value}' expected to be of type boolean.` };
                    }
                    return { success: true, value: value };
                  })(value["value"]);
                })();
                if (!parsed_value.success) {
                  return { success: false, reason: parsed_value.reason };
                }
                return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
              })(value);
            })(value["subNullable"]);
          })();
          if (!parsed_subNullable.success) {
            return { success: false, reason: parsed_subNullable.reason };
          }
          return { success: true, value: { kind: parsed_kind.value, sharedProp: parsed_sharedProp.value, subNonNullable: parsed_subNonNullable.value, subNullable: parsed_subNullable.value } };
        })(value);
      })(value["bbb"]);
    })();
    if (!parsed_bbb.success) {
      return { success: false, reason: parsed_bbb.reason };
    }
    return { success: true, value: { bbb: parsed_bbb.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfWithOverlappingProperties
export function serialize_OneOfWithOverlappingProperties(obj: OneOfWithOverlappingProperties): string {
  const serialized = ((value: { kind: "str"; value: string } | { kind: "num"; value: number }): unknown => {
    switch (value.kind) {
      case "str": {
        return {
          kind: "str",
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "num": {
        return {
          kind: "num",
          value: ((value: number): unknown => {
            return value;
          })(value["value"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfWithOverlappingProperties(str: string): ParserResult<OneOfWithOverlappingProperties> {
  return ((value: unknown): ParserResult<{ kind: "str"; value: string } | { kind: "num"; value: number }> => {
    return ((value: unknown): ParserResult<{ kind: "str"; value: string } | { kind: "num"; value: number }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "str": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            value: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties/str]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties/str]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties/str/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties/str/value]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "str" as const, ...parsedVariant.value } };
        }
        case "num": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            value: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties/num]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties/num]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties/num/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties/num/value]: '${value}' expected to be of type number.` };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "num" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/OneOfWithOverlappingProperties]: '${discriminator}' expected to be one of 'str, num'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfWithRef
export function serialize_OneOfWithRef(obj: OneOfWithRef): string {
  const serialized = ((value: { kind: "elem"; value: string }): unknown => {
    switch (value.kind) {
      case "elem": {
        return {
          kind: "elem",
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfWithRef(str: string): ParserResult<OneOfWithRef> {
  return ((value: unknown): ParserResult<{ kind: "elem"; value: string }> => {
    return ((value: unknown): ParserResult<{ kind: "elem"; value: string }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/OneOfWithRef]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/OneOfWithRef]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/OneOfWithRef]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/OneOfWithRef]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "elem": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            value: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/OneOfWithRef/elem]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/OneOfWithRef/elem]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/OneOfWithRef/elem/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/OneOfWithRef/elem/value]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "elem" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/OneOfWithRef]: '${discriminator}' expected to be one of 'elem'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfWithRefElem
export function serialize_OneOfWithRefElem(obj: OneOfWithRefElem): string {
  const serialized = ((value: { kind: OneOfWithRefElemKind; value: string }): unknown => {
    return {
      kind: ((value: "elem"): unknown => {
        return value;
      })(value["kind"]),
      value: ((value: string): unknown => {
        return value;
      })(value["value"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfWithRefElem(str: string): ParserResult<OneOfWithRefElem> {
  return ((
    value: unknown,
  ): ParserResult<{
    kind: OneOfWithRefElemKind;
    value: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/OneOfWithRefElem]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/OneOfWithRefElem]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/OneOfWithRefElem/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<OneOfWithRefElemKind> => {
      return ((value: unknown): ParserResult<OneOfWithRefElemKind> => {
        return ((value: unknown): ParserResult<"elem"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/OneOfWithRefElemKind]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "elem":
              return { success: true, value: "elem" };
            default:
              return { success: false, reason: `[#/components/schemas/OneOfWithRefElemKind]: '${value}' expected to be enum, one of 'elem'.` };
          }
        })(value);
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    if (!hasProp(value, "value")) {
      return { success: false, reason: `[#/components/schemas/OneOfWithRefElem/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
    }
    const parsed_value = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OneOfWithRefElem/value]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["value"]);
    })();
    if (!parsed_value.success) {
      return { success: false, reason: parsed_value.reason };
    }
    return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// OneOfWithRefElemKind
export function serialize_OneOfWithRefElemKind(obj: OneOfWithRefElemKind): string {
  const serialized = ((value: "elem"): unknown => {
    return value;
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OneOfWithRefElemKind(str: string): ParserResult<OneOfWithRefElemKind> {
  return ((value: unknown): ParserResult<"elem"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/OneOfWithRefElemKind]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "elem":
        return { success: true, value: "elem" };
      default:
        return { success: false, reason: `[#/components/schemas/OneOfWithRefElemKind]: '${value}' expected to be enum, one of 'elem'.` };
    }
  })(parseJsonWithNumbersAsBigint(str));
}

// RefArrayContainer
export function serialize_RefArrayContainer(obj: RefArrayContainer): string {
  const serialized = ((value: { arr1: SubModel[]; arr2: SubModel[] | null; arr3?: SubModel[]; arr4?: SubModel[] | null }): unknown => {
    return {
      arr1: ((value: SubModel[]): unknown => {
        return value.map((value: { intValue: number }): unknown => {
          return {
            intValue: ((value: number): unknown => {
              return value;
            })(value["intValue"]),
          };
        });
      })(value["arr1"]),
      arr2: ((value: SubModel[] | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.map((value: { intValue: number }): unknown => {
          return {
            intValue: ((value: number): unknown => {
              return value;
            })(value["intValue"]),
          };
        });
      })(value["arr2"]),
      arr3: ((value: SubModel[] | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value.map((value: { intValue: number }): unknown => {
          return {
            intValue: ((value: number): unknown => {
              return value;
            })(value["intValue"]),
          };
        });
      })(value["arr3"]),
      arr4: ((value: SubModel[] | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value.map((value: { intValue: number }): unknown => {
          return {
            intValue: ((value: number): unknown => {
              return value;
            })(value["intValue"]),
          };
        });
      })(value["arr4"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_RefArrayContainer(str: string): ParserResult<RefArrayContainer> {
  return ((
    value: unknown,
  ): ParserResult<{
    arr1: SubModel[];
    arr2: SubModel[] | null;
    arr3?: SubModel[];
    arr4?: SubModel[] | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/RefArrayContainer]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/RefArrayContainer]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "arr1")) {
      return { success: false, reason: `[#/components/schemas/RefArrayContainer/arr1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr1'.` };
    }
    const parsed_arr1 = ((): ParserResult<SubModel[]> => {
      return ((value: unknown): ParserResult<SubModel[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/RefArrayContainer/arr1]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<SubModel> => {
          return ((
            value: unknown,
          ): ParserResult<{
            intValue: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "intValue")) {
              return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
            }
            const parsed_intValue = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${value}' expected to be of type number.` };
              })(value["intValue"]);
            })();
            if (!parsed_intValue.success) {
              return { success: false, reason: parsed_intValue.reason };
            }
            return { success: true, value: { intValue: parsed_intValue.value } };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/RefArrayContainer/arr1]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr1"]);
    })();
    if (!parsed_arr1.success) {
      return { success: false, reason: parsed_arr1.reason };
    }
    if (!hasProp(value, "arr2")) {
      return { success: false, reason: `[#/components/schemas/RefArrayContainer/arr2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr2'.` };
    }
    const parsed_arr2 = ((): ParserResult<SubModel[] | null> => {
      return ((value: unknown): ParserResult<SubModel[] | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/RefArrayContainer/arr2]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<SubModel> => {
          return ((
            value: unknown,
          ): ParserResult<{
            intValue: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "intValue")) {
              return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
            }
            const parsed_intValue = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${value}' expected to be of type number.` };
              })(value["intValue"]);
            })();
            if (!parsed_intValue.success) {
              return { success: false, reason: parsed_intValue.reason };
            }
            return { success: true, value: { intValue: parsed_intValue.value } };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/RefArrayContainer/arr2]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr2"]);
    })();
    if (!parsed_arr2.success) {
      return { success: false, reason: parsed_arr2.reason };
    }
    const parsed_arr3 = ((): ParserResult<SubModel[] | undefined> => {
      if (!hasProp(value, "arr3")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<SubModel[] | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/RefArrayContainer/arr3]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<SubModel> => {
          return ((
            value: unknown,
          ): ParserResult<{
            intValue: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "intValue")) {
              return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
            }
            const parsed_intValue = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${value}' expected to be of type number.` };
              })(value["intValue"]);
            })();
            if (!parsed_intValue.success) {
              return { success: false, reason: parsed_intValue.reason };
            }
            return { success: true, value: { intValue: parsed_intValue.value } };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/RefArrayContainer/arr3]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr3"]);
    })();
    if (!parsed_arr3.success) {
      return { success: false, reason: parsed_arr3.reason };
    }
    const parsed_arr4 = ((): ParserResult<SubModel[] | null | undefined> => {
      if (!hasProp(value, "arr4")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<SubModel[] | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/RefArrayContainer/arr4]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<SubModel> => {
          return ((
            value: unknown,
          ): ParserResult<{
            intValue: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "intValue")) {
              return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
            }
            const parsed_intValue = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${value}' expected to be of type number.` };
              })(value["intValue"]);
            })();
            if (!parsed_intValue.success) {
              return { success: false, reason: parsed_intValue.reason };
            }
            return { success: true, value: { intValue: parsed_intValue.value } };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/RefArrayContainer/arr4]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr4"]);
    })();
    if (!parsed_arr4.success) {
      return { success: false, reason: parsed_arr4.reason };
    }
    return { success: true, value: { arr1: parsed_arr1.value, arr2: parsed_arr2.value, arr3: parsed_arr3.value, arr4: parsed_arr4.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// ReservedKeywords
export function serialize_ReservedKeywords(obj: ReservedKeywords): string {
  const serialized = ((value: { object?: string; val?: string; var?: string }): unknown => {
    return {
      object: ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["object"]),
      val: ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["val"]),
      var: ((value: string | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value;
      })(value["var"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ReservedKeywords(str: string): ParserResult<ReservedKeywords> {
  return ((
    value: unknown,
  ): ParserResult<{
    object?: string;
    val?: string;
    var?: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ReservedKeywords]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ReservedKeywords]: '${value}' expected to not be null.` };
    }
    const parsed_object = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "object")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ReservedKeywords/object]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["object"]);
    })();
    if (!parsed_object.success) {
      return { success: false, reason: parsed_object.reason };
    }
    const parsed_val = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "val")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ReservedKeywords/val]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["val"]);
    })();
    if (!parsed_val.success) {
      return { success: false, reason: parsed_val.reason };
    }
    const parsed_var = ((): ParserResult<string | undefined> => {
      if (!hasProp(value, "var")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ReservedKeywords/var]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["var"]);
    })();
    if (!parsed_var.success) {
      return { success: false, reason: parsed_var.reason };
    }
    return { success: true, value: { object: parsed_object.value, val: parsed_val.value, var: parsed_var.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// StringArrayContainer
export function serialize_StringArrayContainer(obj: StringArrayContainer): string {
  const serialized = ((value: {
    arr1: string[];
    arr2: string[] | null;
    arr3: (string | null)[];
    arr4: (string | null)[] | null;
    arr5?: string[];
    arr6?: string[] | null;
    arr7?: (string | null)[];
    arr8?: (string | null)[] | null;
  }): unknown => {
    return {
      arr1: ((value: string[]): unknown => {
        return value.map((value: string): unknown => {
          return value;
        });
      })(value["arr1"]),
      arr2: ((value: string[] | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.map((value: string): unknown => {
          return value;
        });
      })(value["arr2"]),
      arr3: ((value: (string | null)[]): unknown => {
        return value.map((value: string | null): unknown => {
          if (value === null) {
            return null;
          }
          return value;
        });
      })(value["arr3"]),
      arr4: ((value: (string | null)[] | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.map((value: string | null): unknown => {
          if (value === null) {
            return null;
          }
          return value;
        });
      })(value["arr4"]),
      arr5: ((value: string[] | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value.map((value: string): unknown => {
          return value;
        });
      })(value["arr5"]),
      arr6: ((value: string[] | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value.map((value: string): unknown => {
          return value;
        });
      })(value["arr6"]),
      arr7: ((value: (string | null)[] | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        return value.map((value: string | null): unknown => {
          if (value === null) {
            return null;
          }
          return value;
        });
      })(value["arr7"]),
      arr8: ((value: (string | null)[] | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value.map((value: string | null): unknown => {
          if (value === null) {
            return null;
          }
          return value;
        });
      })(value["arr8"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_StringArrayContainer(str: string): ParserResult<StringArrayContainer> {
  return ((
    value: unknown,
  ): ParserResult<{
    arr1: string[];
    arr2: string[] | null;
    arr3: (string | null)[];
    arr4: (string | null)[] | null;
    arr5?: string[];
    arr6?: string[] | null;
    arr7?: (string | null)[];
    arr8?: (string | null)[] | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/StringArrayContainer]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/StringArrayContainer]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "arr1")) {
      return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr1'.` };
    }
    const parsed_arr1 = ((): ParserResult<string[]> => {
      return ((value: unknown): ParserResult<string[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr1]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr1]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/StringArrayContainer/arr1]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr1"]);
    })();
    if (!parsed_arr1.success) {
      return { success: false, reason: parsed_arr1.reason };
    }
    if (!hasProp(value, "arr2")) {
      return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr2'.` };
    }
    const parsed_arr2 = ((): ParserResult<string[] | null> => {
      return ((value: unknown): ParserResult<string[] | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr2]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr2]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/StringArrayContainer/arr2]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr2"]);
    })();
    if (!parsed_arr2.success) {
      return { success: false, reason: parsed_arr2.reason };
    }
    if (!hasProp(value, "arr3")) {
      return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr3]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr3'.` };
    }
    const parsed_arr3 = ((): ParserResult<(string | null)[]> => {
      return ((value: unknown): ParserResult<(string | null)[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr3]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string | null> => {
          if (value === null) {
            return { success: true, value: null };
          }
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr3]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/StringArrayContainer/arr3]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr3"]);
    })();
    if (!parsed_arr3.success) {
      return { success: false, reason: parsed_arr3.reason };
    }
    if (!hasProp(value, "arr4")) {
      return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr4]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'arr4'.` };
    }
    const parsed_arr4 = ((): ParserResult<(string | null)[] | null> => {
      return ((value: unknown): ParserResult<(string | null)[] | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr4]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string | null> => {
          if (value === null) {
            return { success: true, value: null };
          }
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr4]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/StringArrayContainer/arr4]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr4"]);
    })();
    if (!parsed_arr4.success) {
      return { success: false, reason: parsed_arr4.reason };
    }
    const parsed_arr5 = ((): ParserResult<string[] | undefined> => {
      if (!hasProp(value, "arr5")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string[] | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr5]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr5]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/StringArrayContainer/arr5]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr5"]);
    })();
    if (!parsed_arr5.success) {
      return { success: false, reason: parsed_arr5.reason };
    }
    const parsed_arr6 = ((): ParserResult<string[] | null | undefined> => {
      if (!hasProp(value, "arr6")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<string[] | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr6]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr6]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/StringArrayContainer/arr6]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr6"]);
    })();
    if (!parsed_arr6.success) {
      return { success: false, reason: parsed_arr6.reason };
    }
    const parsed_arr7 = ((): ParserResult<(string | null)[] | undefined> => {
      if (!hasProp(value, "arr7")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<(string | null)[] | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr7]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string | null> => {
          if (value === null) {
            return { success: true, value: null };
          }
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr7]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/StringArrayContainer/arr7]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr7"]);
    })();
    if (!parsed_arr7.success) {
      return { success: false, reason: parsed_arr7.reason };
    }
    const parsed_arr8 = ((): ParserResult<(string | null)[] | null | undefined> => {
      if (!hasProp(value, "arr8")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<(string | null)[] | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr8]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string | null> => {
          if (value === null) {
            return { success: true, value: null };
          }
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/StringArrayContainer/arr8]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/StringArrayContainer/arr8]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr8"]);
    })();
    if (!parsed_arr8.success) {
      return { success: false, reason: parsed_arr8.reason };
    }
    return { success: true, value: { arr1: parsed_arr1.value, arr2: parsed_arr2.value, arr3: parsed_arr3.value, arr4: parsed_arr4.value, arr5: parsed_arr5.value, arr6: parsed_arr6.value, arr7: parsed_arr7.value, arr8: parsed_arr8.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// SubModel
export function serialize_SubModel(obj: SubModel): string {
  const serialized = ((value: { intValue: number }): unknown => {
    return {
      intValue: ((value: number): unknown => {
        return value;
      })(value["intValue"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_SubModel(str: string): ParserResult<SubModel> {
  return ((
    value: unknown,
  ): ParserResult<{
    intValue: number;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/SubModel]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "intValue")) {
      return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'intValue'.` };
    }
    const parsed_intValue = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SubModel/intValue]: '${value}' expected to be of type number.` };
      })(value["intValue"]);
    })();
    if (!parsed_intValue.success) {
      return { success: false, reason: parsed_intValue.reason };
    }
    return { success: true, value: { intValue: parsed_intValue.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// SuperExample
export function serialize_SuperExample(obj: SuperExample): string {
  const serialized = ((value: { kind: "AAA"; value: string } | { kind: "BBB"; value: boolean }): unknown => {
    switch (value.kind) {
      case "AAA": {
        return {
          kind: "AAA",
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "BBB": {
        return {
          kind: "BBB",
          value: ((value: boolean): unknown => {
            return value;
          })(value["value"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_SuperExample(str: string): ParserResult<SuperExample> {
  return ((value: unknown): ParserResult<{ kind: "AAA"; value: string } | { kind: "BBB"; value: boolean }> => {
    return ((value: unknown): ParserResult<{ kind: "AAA"; value: string } | { kind: "BBB"; value: boolean }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/SuperExample]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/SuperExample]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/SuperExample]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/SuperExample]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "AAA": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            value: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/SuperExample/AAA]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/SuperExample/AAA]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/SuperExample/AAA/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/SuperExample/AAA/value]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "AAA" as const, ...parsedVariant.value } };
        }
        case "BBB": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            value: boolean;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/SuperExample/BBB]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/SuperExample/BBB]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/SuperExample/BBB/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/SuperExample/BBB/value]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "BBB" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/SuperExample]: '${discriminator}' expected to be one of 'AAA, BBB'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}

// SuperExample_AAA
export function serialize_SuperExample_AAA(obj: SuperExample_AAA): string {
  const serialized = ((value: { kind: "AAA"; value: string }): unknown => {
    return {
      kind: ((value: "AAA"): unknown => {
        return value;
      })(value["kind"]),
      value: ((value: string): unknown => {
        return value;
      })(value["value"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_SuperExample_AAA(str: string): ParserResult<SuperExample_AAA> {
  return ((
    value: unknown,
  ): ParserResult<{
    kind: "AAA";
    value: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/SuperPartAExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<"AAA"> => {
      return ((value: unknown): ParserResult<"AAA"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "AAA":
            return { success: true, value: "AAA" };
          default:
            return { success: false, reason: `[#/components/schemas/SuperPartAExample/kind]: '${value}' expected to be enum, one of 'AAA'.` };
        }
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    if (!hasProp(value, "value")) {
      return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
    }
    const parsed_value = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SuperPartAExample/value]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["value"]);
    })();
    if (!parsed_value.success) {
      return { success: false, reason: parsed_value.reason };
    }
    return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// SuperExample_BBB
export function serialize_SuperExample_BBB(obj: SuperExample_BBB): string {
  const serialized = ((value: { kind: "BBB"; value: boolean }): unknown => {
    return {
      kind: ((value: "BBB"): unknown => {
        return value;
      })(value["kind"]),
      value: ((value: boolean): unknown => {
        return value;
      })(value["value"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_SuperExample_BBB(str: string): ParserResult<SuperExample_BBB> {
  return ((
    value: unknown,
  ): ParserResult<{
    kind: "BBB";
    value: boolean;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/SuperPartBExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<"BBB"> => {
      return ((value: unknown): ParserResult<"BBB"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "BBB":
            return { success: true, value: "BBB" };
          default:
            return { success: false, reason: `[#/components/schemas/SuperPartBExample/kind]: '${value}' expected to be enum, one of 'BBB'.` };
        }
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    if (!hasProp(value, "value")) {
      return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
    }
    const parsed_value = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/SuperPartBExample/value]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["value"]);
    })();
    if (!parsed_value.success) {
      return { success: false, reason: parsed_value.reason };
    }
    return { success: true, value: { kind: parsed_kind.value, value: parsed_value.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// TimeStampExample
export function serialize_TimeStampExample(obj: TimeStampExample): string {
  const serialized = ((value: { ts: DateTime<true> }): unknown => {
    return {
      ts: ((value: DateTime<true>): unknown => {
        return value.toMillis();
      })(value["ts"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_TimeStampExample(str: string): ParserResult<TimeStampExample> {
  return ((
    value: unknown,
  ): ParserResult<{
    ts: DateTime<true>;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/TimeStampExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/TimeStampExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "ts")) {
      return { success: false, reason: `[#/components/schemas/TimeStampExample/ts]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ts'.` };
    }
    const parsed_ts = ((): ParserResult<DateTime<true>> => {
      return ((value: unknown): ParserResult<DateTime<true>> => {
        if (typeof value !== "number") {
          return { success: false, reason: `[#/components/schemas/TimeStampExample/ts]: '${value}' expected to be of type number.` };
        }
        const parsed = DateTime.fromMillis(value);
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/TimeStampExample/ts]: '${value}' expected to be valid DateTime.` };
        }
        return { success: true, value: parsed };
      })(value["ts"]);
    })();
    if (!parsed_ts.success) {
      return { success: false, reason: parsed_ts.reason };
    }
    return { success: true, value: { ts: parsed_ts.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// UnNamedEnumInArr
export function serialize_UnNamedEnumInArr(obj: UnNamedEnumInArr): string {
  const serialized = ((value: { arr?: (("FOO" | "BAR") | null)[] | null }): unknown => {
    return {
      arr: ((value: (("FOO" | "BAR") | null)[] | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value.map((value: ("FOO" | "BAR") | null): unknown => {
          if (value === null) {
            return null;
          }
          return value;
        });
      })(value["arr"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_UnNamedEnumInArr(str: string): ParserResult<UnNamedEnumInArr> {
  return ((
    value: unknown,
  ): ParserResult<{
    arr?: (("FOO" | "BAR") | null)[] | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/UnNamedEnumInArr]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/UnNamedEnumInArr]: '${value}' expected to not be null.` };
    }
    const parsed_arr = ((): ParserResult<(("FOO" | "BAR") | null)[] | null | undefined> => {
      if (!hasProp(value, "arr")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<(("FOO" | "BAR") | null)[] | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/UnNamedEnumInArr/arr]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<("FOO" | "BAR") | null> => {
          if (value === null) {
            return { success: true, value: null };
          }
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/UnNamedEnumInArr/arr/[string]]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "FOO":
              return { success: true, value: "FOO" };
            case "BAR":
              return { success: true, value: "BAR" };
            default:
              return { success: false, reason: `[#/components/schemas/UnNamedEnumInArr/arr/[string]]: '${value}' expected to be enum, one of 'FOO, BAR'.` };
          }
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/UnNamedEnumInArr/arr]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["arr"]);
    })();
    if (!parsed_arr.success) {
      return { success: false, reason: parsed_arr.reason };
    }
    return { success: true, value: { arr: parsed_arr.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// UnnamedEnumInObj
export function serialize_UnnamedEnumInObj(obj: UnnamedEnumInObj): string {
  const serialized = ((value: { enumvalue?: ("FOO" | "BAR") | null }): unknown => {
    return {
      enumvalue: ((value: ("FOO" | "BAR") | null | undefined): unknown => {
        if (value === undefined) {
          return undefined;
        }
        if (value === null) {
          return null;
        }
        return value;
      })(value["enumvalue"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_UnnamedEnumInObj(str: string): ParserResult<UnnamedEnumInObj> {
  return ((
    value: unknown,
  ): ParserResult<{
    enumvalue?: ("FOO" | "BAR") | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/UnnamedEnumInObj]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/UnnamedEnumInObj]: '${value}' expected to not be null.` };
    }
    const parsed_enumvalue = ((): ParserResult<("FOO" | "BAR") | null | undefined> => {
      if (!hasProp(value, "enumvalue")) {
        return { success: true, value: undefined };
      }
      return ((value: unknown): ParserResult<("FOO" | "BAR") | null | undefined> => {
        if (value === undefined) {
          return { success: true, value: undefined };
        }
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/UnnamedEnumInObj/enumvalue]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "FOO":
            return { success: true, value: "FOO" };
          case "BAR":
            return { success: true, value: "BAR" };
          default:
            return { success: false, reason: `[#/components/schemas/UnnamedEnumInObj/enumvalue]: '${value}' expected to be enum, one of 'FOO, BAR'.` };
        }
      })(value["enumvalue"]);
    })();
    if (!parsed_enumvalue.success) {
      return { success: false, reason: parsed_enumvalue.reason };
    }
    return { success: true, value: { enumvalue: parsed_enumvalue.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// UriExample
export function serialize_UriExample(obj: UriExample): string {
  const serialized = ((value: { url: string }): unknown => {
    return {
      url: ((value: string): unknown => {
        return value;
      })(value["url"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_UriExample(str: string): ParserResult<UriExample> {
  return ((
    value: unknown,
  ): ParserResult<{
    url: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/UriExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/UriExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "url")) {
      return { success: false, reason: `[#/components/schemas/UriExample/url]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'url'.` };
    }
    const parsed_url = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/UriExample/url]: '${value}' expected to be of type string.` };
        }
        try {
          new URL(value);
        } catch (ex) {
          return { success: false, reason: `[#/components/schemas/UriExample/url]: '${value}' expected to be a valid url.` };
        }
        return { success: true, value: value };
      })(value["url"]);
    })();
    if (!parsed_url.success) {
      return { success: false, reason: parsed_url.reason };
    }
    return { success: true, value: { url: parsed_url.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// UrlExample
export function serialize_UrlExample(obj: UrlExample): string {
  const serialized = ((value: { url: string }): unknown => {
    return {
      url: ((value: string): unknown => {
        return value;
      })(value["url"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_UrlExample(str: string): ParserResult<UrlExample> {
  return ((
    value: unknown,
  ): ParserResult<{
    url: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/UrlExample]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/UrlExample]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "url")) {
      return { success: false, reason: `[#/components/schemas/UrlExample/url]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'url'.` };
    }
    const parsed_url = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/UrlExample/url]: '${value}' expected to be of type string.` };
        }
        try {
          new URL(value);
        } catch (ex) {
          return { success: false, reason: `[#/components/schemas/UrlExample/url]: '${value}' expected to be a valid url.` };
        }
        return { success: true, value: value };
      })(value["url"]);
    })();
    if (!parsed_url.success) {
      return { success: false, reason: parsed_url.reason };
    }
    return { success: true, value: { url: parsed_url.value } };
  })(parseJsonWithNumbersAsBigint(str));
}

// ValidationErrorReasons
export function serialize_ValidationErrorReasons(obj: ValidationErrorReasons): string {
  const serialized = ((value: { fields: { additionalProperties: Record<string, string[]> }; general: string[] }): unknown => {
    return {
      fields: ((value: { additionalProperties: Record<string, string[]> }): unknown => {
        const unordered_obj: Record<string, unknown> = {
          ...Object.fromEntries(
            Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
              return [
                propertyKey,
                ((value: string[]): unknown => {
                  return value.map((value: string): unknown => {
                    return value;
                  });
                })(propertyValue),
              ];
            }),
          ),
        };
        return Object.keys(unordered_obj)
          .sort()
          .reduce(
            (obj, key) => {
              obj[key] = unordered_obj[key];
              return obj;
            },
            {} as Record<string, unknown>,
          );
      })(value["fields"]),
      general: ((value: string[]): unknown => {
        return value.map((value: string): unknown => {
          return value;
        });
      })(value["general"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ValidationErrorReasons(str: string): ParserResult<ValidationErrorReasons> {
  return ((
    value: unknown,
  ): ParserResult<{
    fields: { additionalProperties: Record<string, string[]> };
    general: string[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "fields")) {
      return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fields'.` };
    }
    const parsed_fields = ((): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
      return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to not be null.` };
        }
        const parsed_additionalProperties = ((): ParserResult<Record<string, string[]>> => {
          const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string[]>] => {
            return [
              key,
              ((value: unknown): ParserResult<string[]> => {
                if (!isArray(value)) {
                  return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: '${value}' expected to be an array.` };
                }
                const parsed = value.map((value: unknown): ParserResult<string> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/additionalProperty]: '${value}' expected to be of type string.` };
                  }
                  return { success: true, value: value };
                });
                if (parsed.find((value) => !value.success) !== undefined) {
                  return {
                    success: false,
                    reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: Reason(s): '${parsed
                      .filter((p) => !p.success)
                      .map((p) => p.reason)
                      .join(", ")}'.`,
                  };
                }
                return {
                  success: true,
                  value: parsed.map((entry) => {
                    assert(entry.success == true);
                    return entry.value;
                  }),
                };
              })(value),
            ];
          });
          if (parsed.find(([_, value]) => !value.success) !== undefined) {
            return {
              success: false,
              reason: `[#/components/schemas/ValidationErrorReasons/fields]: Reason(s): '${parsed
                .map(([_, value]) => value)
                .filter((p) => !p.success)
                .map((p) => p.reason)
                .join(", ")}'.`,
            };
          }
          return {
            success: true,
            value: Object.fromEntries(
              parsed.map(([key, value]) => {
                assert(value.success);
                return [key, value.value];
              }),
            ),
          };
        })();
        if (!parsed_additionalProperties.success) {
          return { success: false, reason: parsed_additionalProperties.reason };
        }
        return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
      })(value["fields"]);
    })();
    if (!parsed_fields.success) {
      return { success: false, reason: parsed_fields.reason };
    }
    if (!hasProp(value, "general")) {
      return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'general'.` };
    }
    const parsed_general = ((): ParserResult<string[]> => {
      return ((value: unknown): ParserResult<string[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ValidationErrorReasons/general]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["general"]);
    })();
    if (!parsed_general.success) {
      return { success: false, reason: parsed_general.reason };
    }
    return { success: true, value: { fields: parsed_fields.value, general: parsed_general.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
